<template>
  <h1>{{dataModule['modules.pageName']}}</h1>
  <p class="infoView" data-toggle="collapse" href="#infoView" role="button" aria-expanded="false" aria-controls="infoView">Info</p>
  <div class="collapse" id="infoView">
    <div class="row">
      <div class="card card-body col-12">
        <p style="color: #949494; margin:0; font-size: 12px;"  v-for="(item, index) in dataModule" :key="index" > <span v-if="index != 'attributes' && index != 'strAtt'"><strong>{{index}}: </strong>{{ item }} </span></p > 
      </div>
    </div>
  </div>
  <br>
  <div class="smart-wrap">  
    <div class="input-wrap col-md-2">
      <label style="width:100%;" for="">Search..</label>
      <input   type="text" id="searchTableInput" v-on:keyup.enter="searchList" title="Type in a name" v-model="v_search" autocomplete="off"/>
      <i class="bx bx-x clearSearch"  v-on:click="clearSearch()"></i>
    </div>
    <div class="input-wrap col-md-1">
      <label for="">View </label>
      <select v-model="activeStatus" v-on:change="f_ListDataSet(pageQuery)">
        <option value="1">Active</option>
        <option value="2">Archived</option>
        <option value="0">Deleted</option>
        <option value="3">All but Deleted</option>
        <option value="4">All</option>
      </select> 
    </div>
    <div class="input-wrap col-md-1"> 
      <label for="">Rows </label>
      <!--input type="number" min="0" v-model="pageSize" v-on:change="f_ListDataSet()"-->
      <input type="number" min="10" step="10" max="250" v-on:keyup.enter="setItemsTable" v-model="pageSize" >
    </div>
    <div v-if="dataModule.allowSelectPK == true" class="input-wrap col-md-1">
      <div v-if="this.userPermissions.includes('Superadmin') || this.userPermissions.includes('Admin')">
        <label for="">PK</label>
        <select name="" id=""  v-model="systemType" v-on:change="listDataSet()">
          <option selected disabled hidden>select an option</option>
          <option value="#SMARTDASH">System</option>
          <option :value="item.value" v-for="(item, index) in preloadLists['#ORG']" :key="index">
            {{ item.value.replace("ORG#", "") }}
          </option>
        </select>
      </div>
      <div v-else>
        <label for="">PK</label>
        <select name="" id=""  v-model="systemType" v-on:change="listDataSet()">
          <option selected disabled hidden>select an option</option>
          <option value="#SMARTDASH">System</option>
          <option :value="organizationID">
            {{ organizationID.replace("ORG#", "") }}
          </option>
        </select>
      </div>
      
    </div>
    <div v-if="dataModule.preload != true" class="input-wrap col-md-1">
      <label for="">Status</label>
      <select name="" id="" v-model="statusFilter" v-on:change="setFilterData(['statusFilter',statusFilter]); dateFilter = '' ; rangeFilter= '';listDataSet() ">
        <option :value="option" v-for="(option, index) in statusTableFilter" :key="index">{{option}}</option> 
        <option value="All" >All</option> 
      </select>
    </div>
    <div v-if="dataModule.preload != true" class="input-wrap col-md-1">
      <label for="">Index</label>
      <select name="" id=""  v-model="dateFilter"  v-on:change="setFilterData(['dateFilter',dateFilter]); statusFilter = ''; setFilterData(['statusFilter','']); listDataSet();">
        <option value="Created">Created</option>
        <option v-if="entities[dataModule['modules.dataQuery']].GSI4Label != undefined && entities[dataModule['modules.dataQuery']].GSI4Label != ''" :value="entities[dataModule['modules.dataQuery']].GSI4Label">{{entities[dataModule['modules.dataQuery']].GSI4Label}}</option>
      </select>
    </div>
    <div v-if="dataModule.preload != true" class="input-wrap col-md-1">
      <label for="">Range</label>
      <select name="" id=""  v-model="rangeFilter"   v-on:change="setFilterData(['rangeFilter',rangeFilter]); statusFilter = ''; setFilterData(['statusFilter','']); listDataSet()">
        <option value="Today">Today</option>
        <option value="Yesterday">Yesterday</option>
        <option value="This Week">This Week</option>
        <option value="This Month">This Month</option>
        <option value="Last Month">Last Month</option>
        <option value="This Year">This Year</option>
        <option value="Range">Range</option>
      </select>
    </div>
    <div v-if="dataModule.preload == true" class="col-md-4"></div>
    <div class="element-wrap col-md-4" style="float: rigth;">
      <br>
      <ui-button :style="'background:'+organizationData.colorSeriesA[0]+'; margin: 0 0 0 10px;'" :color="'green'" :text="'New '" :position="'right'" data-toggle="modal" data-target="#modal-updateOld" v-on:click="getItem({sml:{PK:dataModule['modules.formSK'].PK , SK:dataModule['modules.formSK'].SK}, entity:{ PK: dataModule['modules.mainEntity'].PK, SK:dataModule['modules.mainEntity'].SK}}, item.edit, item.PK, item.SK , false)" />
      <ui-button v-if="dataModule.preload == true" :style="'background:'+organizationData.colorSeriesA[1]+'; margin: 0 0 0 10px;'" :color="'gray'" :text="''" :position="'right'" v-on:click="refreshTable()">
        <i class='bx bx-refresh'></i>
      </ui-button>
      
      <ui-button v-else :style="'background:'+organizationData.colorSeriesA[1]+'; margin: 0 0 0 10px;'" :color="'gray'" :text="''" :position="'right'" v-on:click="listDataSet()">
        <i class='bx bx-refresh'></i>
      </ui-button>

      <!--div class="dropdown">
      <ui-button style="margin: 0 0 0 10px;" :color="'gray'" :text="''" :position="'right'"  id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i class='bx bx-filter' ></i>
      </ui-button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuLink" v >
        <div class="smart-wrap">
          
          <div class="element-wrap col-md-12" v-for="(filterItem, index) in filter" :key="index">
            <h6>{{index}}</h6>
            <div class="input-wrap col-md-12" v-for="(inputFilter, zindex) in filterItem" :key="zindex" > 
              <label for="">{{inputFilter}}</label> <br>
              <input type="checkbox" :value="inputFilter" v-model="valueFilter" v-on:click="applyFilter(index)">
            </div>
          </div>
        </div>
      </div>
      </div-->
    </div>
  </div>
  <br>
  <!-- TABLE -->
  <div class="smart-wrap">
    <div class="element-wrap col-md-12">
      <div class="pagination">
        <a href="#">&laquo;</a>
        <a href="#" :id="'pagination-'+index" v-for="(item, index) in pagination[0]" :key="index" v-on:click="pagination[1] = (index)*pageSize" > {{ index+1 }} </a>
        <a href="#">&raquo;</a>
      </div>
    </div> 
    <div class="element-wrap col-md-12">
      <span style="display:none;" v-for="(item, index) in ramData.data" :key="index" > <strong>{{item.friendlyId}}</strong> {{item.SK}}<br></span> 
      <table v-if="ramData.headersV2 != undefined && ramData.headersV2 != ''" class="table" id="myTable">  
        <thead>
          <th class="index">Old</th>
          <th v-for="(column, indexcolumns) in ramData.headersV2" :key="indexcolumns">
            <div class="dropdown">
              <span v-on:click="sortTable(indexcolumns+1)">
                {{ column.label }}
              </span>
              <a style="cursor:pointer;" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-if="column.filter">
                <svg  width="16" height="12" viewBox="0 0 28 24" fill="none" style="margin: 0px 0px 0px 10px; cursor:pointer;">
                  <path d="M10.8889 24L17.1111 20V13.6L28 0H0L10.8889 13.6V24Z" fill="#383838"/>
                </svg>
              </a>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuLink" v-if="column.filter">
                <div class="smart-wrap">
                    {{indexcolumns+ '-'+ valueFilter}}
                  <div class="input-wrap col-md-12" v-for="(filterItem, i) in column.filter" :key="i" >
                    {{filterItem}}
                    <input type="checkbox" :value="filterItem" v-model="valueFilter" v-on:click="filterTable(indexcolumns+1)">
                  </div>
                </div>
              </div>
            </div>
          </th>
          <th>Actions</th>
        </thead>
        <tbody v-if="pageQuery == 'CON'">
          <tr v-for="(item, index) in ramData.data.slice(pagination[1], pagination[1]+pageSize )" :key="index" :id="'tr-'+index" style="cursor:pointer;" class="tr-hover" >
            <td class="index" v-on:click="blanckPage(item)">
              <span v-if="item.subscribe">
                <i v-if="item.subscribe == 'edit'" class='bx bxs-pencil' style='color:#5ad911'></i>
                <i v-if="item.subscribe == 'new'" class='bx bxs-star' style='color:#0085ff'  ></i>
              </span>
              {{index+1}}
            </td>
            <td v-for="(column, indextd) in ramData.headersV2" :key="indextd" :class="setTdClass(column)" v-on:click="blanckPage(item)">
              <div v-if="column.inputType == 'Combo'">
                <div v-for="(zcolumn, zindex) in column.value" :key="zindex" > 
                  <strong v-if="zcolumn.label != '' && zcolumn.label != undefined ">{{zcolumn.label+':'}}</strong> 
                  <div v-if="zcolumn.repeatable != undefined && zcolumn.repeatable == true ">
                    <span v-for="(xitem, xindex) in formatData('JSON',item[zcolumn.attributeName])" :key="xindex" >
                      <span v-for="(yitem, yindex) in zcolumn.attributes" :key="yindex">
                        <span  v-if="yitem.inputType == 'phoneNumber' ">
                          {{ formatData('phone',xitem[yitem.attributeName])}}
                        </span>
                        <span v-else>
                          {{xitem[yitem.attributeName]+ ' '}}
                        </span>
                        &nbsp;
                      </span> 
                      <br>
                    </span>
                  </div>
                  <div v-else-if="typeof formatData('JSON',item[zcolumn.attributeName]) == 'object'"  >
                    <span v-for="(dataItem, dataindex) in formatData('JSON',item[zcolumn.attributeName])" :key="dataindex" >
                      <span v-if="dataindex != 'PK' && dataindex != 'SK'">
                          {{ dataItem+ ' ' }} 
                      </span>
                    </span>
                  </div>
                  <div v-else > 
                    <span v-if="zcolumn.inputType == '' || zcolumn.inputType == 'preloadList'"> 
                      <div v-for="(zitem, zindex) in formatData('JSON',item[zcolumn.attributeName])" :key="zindex" >
                        <span v-if="zindex != 'PK' && zindex != 'SK'"> 
                          {{zitem}}
                        </span>
                      </div>
                    </span>
                    <span v-else-if="zcolumn.format == 'currency'"> 
                      <span v-if="item[zcolumn.attributeName] == '' || item[zcolumn.attributeName] == 'undefined' || item[zcolumn.attributeName] == undefined" > --.-- </span>
                      <span v-else> {{ (JSON.parse(f_itemValue(item, column.attributeName))).toLocaleString('en-US', { style: 'currency', currency: 'USD'}) }} </span>
                    </span>
                    <span v-else-if="zcolumn.format == 'Date'"> 
                      <span style="display:none;"> {{f_itemValue(item, zcolumn.attributeName)}}</span>
                      {{ formatData('date',item[zcolumn.attributeName])[0]}}  <br> {{ formatData('date',item[zcolumn.attributeName])[1]}}
                    </span>
                    <span v-else-if="zcolumn.attributeName == 'phoneNumber'"> 
                      {{ formatData('phone',item[zcolumn.attributeName])}}
                    </span>
                    <span v-else-if="zcolumn.attributeType == 'Boolean'"> 
                      <i v-if="f_itemValue(item, zcolumn.attributeName) == true" class='bx bxs-check-circle' style='color:#59d000; font-size:22px; opacity:0.6;'></i>
                    </span>
                    <span v-else> 
                      {{ f_itemValue(item, zcolumn.attributeName) }}   
                    </span>
                  </div>
                </div>
              </div>
              <div v-else-if="typeof item[column.attributeName] == 'object'"  >
                <div v-for="(dataItem, dataindex) in f_itemValue(item, column.attributeName)" :key="dataindex" >
                  <span v-if="dataindex != 'PK' && dataindex != 'SK'">
                    <span v-if="typeof dataItem == 'object' " >
                      <span  v-for="(key, xindex) in dataItem" :key="xindex">
                      {{key}}
                      </span>
                    </span>
                    <span v-if="typeof dataItem == 'string'"> 
                      {{ dataItem }} 
                    </span>
                  </span>
                </div>
              </div>
              <div v-else > 
                <span v-if="column.inputType == '' || column.inputType == 'preloadList'"> 
                  <div v-for="(zitem, zindex) in formatData('JSON',item[column.attributeName])" :key="zindex" >
                    <span v-if="zindex != 'PK' && zindex != 'SK'"> 
                      {{zitem}}
                    </span>
                  </div>
                </span>
                <span v-else-if="column.format == 'currency'"> 
                  <span v-if="item[column.attributeName] == '' || item[column.attributeName] == 'undefined' || item[column.attributeName] == undefined" > --.-- </span>
                  <span v-else> {{(JSON.parse(f_itemValue(item, column.attributeName))).toLocaleString('en-US', { style: 'currency', currency: 'USD'}) }} </span>
                </span>
                <span v-else-if="column.format == 'Date'"> 
                  <span style="display:none;"> {{f_itemValue(item, column.attributeName)}}</span>
                  {{ formatData('date',item[column.attributeName])[0]}}    <br> {{ formatData('date',item[column.attributeName])[1]}}  
                </span>
                <span v-else-if="column.attributeName == 'phoneNumber'"> 
                  {{ formatData('phone',item[column.attributeName])}}  
                </span>
                <span v-else-if="column.attributeType == 'Boolean'"> 
                  <i v-if="f_itemValue(item, column.attributeName) == true" class='bx bxs-check-circle' style='color:#59d000; font-size:22px; opacity:0.6;'></i>
                </span>
                <span v-else> 
                  {{ f_itemValue(item, column.attributeName) }}   
                </span>
              </div>
            </td> 
            <td class="options-td">
              <div class="options">   
                <router-link v-if="this.pageQuery == 'MPR'"  :to="{ paht:'/posts', query:{name: 'posts', data:item.SK}}" style="cursor: pointer"  data-placement="top" target="_blank" > 
                  <div class="col send">
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16"><path fill="white" d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/></svg>
                  </div>
                </router-link>
                <div class="dropdown show" v-if="entities[dataModule['modules.dataQuery']]">
                  <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Action">
                    <ui-accion-button action="action"/>
                  </a>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <a class="dropdown-item" style="cursor: pointer; overflow:hidden;"  v-for="(action, aindex) in JSON.parse(entities[dataModule['modules.dataQuery']]['SML.descendantEntitiesWithForm'])" :key="aindex"  v-on:click=" setgRecord([item, 'action',aindex]);" data-toggle="modal" data-target="#modal-update">
                      <ui-accion-button action="action"/>
                      <span v-if="action['metaEntity.descendantEntities'].SK =='#ENT#f9910928-2e9d-4e4b-9a43-19fc1ead11a1'" style="padding: 6px 0; display: block;">
                        {{action['modules.formSK'].value}}
                      </span>
                      <span v-else style="padding: 6px 0; display: block;">
                        {{action['metaEntity.descendantEntities'].value}}
                      </span>
                    </a>
                  </div>
                </div>
                <a v-if="pageQuery == 'CON'" style="cursor: pointer"  v-on:click="f_emailTemplates('list',item.PK , item.SK, item )"  data-toggle="tooltip" data-placement="top" title="Tooltip on top"> 
                  <ui-accion-button action="send"/>
                </a>
                <a style="cursor: pointer" data-toggle="modal" data-target="#modal-archive" v-on:click="getItem({sml:item.form,entity:{PK:'', SK:''},entity:{PK:'', SK:''}},item.edit, item.PK, item.SK)">
                  <ui-accion-button action="archive"/>
                </a>
                <a style="cursor: pointer" v-if="pageQuery == 'QUO'"  data-toggle="modal" data-target="#modal-send"  v-on:click="f_emailTemplates('list',item.PK , item.SK, item )">
                  <ui-accion-button action="send"/>
                </a>
                <router-link v-if="pageQuery == 'QUO'"  :to=" { path: '/checkout', query: { data: item.SK } }"  target="_blank" >
                  <ui-accion-button action="checkout" style="height: 35px; padding: 8px;"/>
                </router-link>
                <a style="cursor: pointer" v-on:click="setFavorite(item.PK, item.SK)" >
                  <ui-accion-button action="favorite"/>
                </a>
                <a style="cursor: pointer" v-on:click="setClone(item.PK, item.SK)" >
                  <ui-accion-button action="clone"/>
                </a>
                <a style="cursor: pointer" data-toggle="modal" data-target="#modal-active" v-on:click="getItem({sml:item.form, entity:{PK:'', SK:''}, entity:{PK:'', SK:''}},item.edit, item.PK, item.SK, undefined, 'delete')">
                  <div class="col delete">
                    <svg width="78" height="100" viewBox="0 0 78 100" fill="none" >
                      <path d="M5.57143 88.8889C5.57143 95 10.5857 100 16.7143 100H61.2857C67.4143 100 72.4286 95 72.4286 88.8889V22.2222H5.57143V88.8889ZM78 5.55556H58.5L52.9286 0H25.0714L19.5 5.55556H0V16.6667H78V5.55556Z" fill="#000" />
                    </svg>
                  </div>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-for="(item, index) in ramData.data.slice(pagination[1], pagination[1]+pageSize )" :key="index" :id="'tr-'+index" style="cursor:pointer;" class="tr-hover" >
            <td class="index"  data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);" >
              <span v-if="item.subscribe">
                <i v-if="item.subscribe == 'edit'" class='bx bxs-pencil' style='color:#5ad911'></i>
                <i v-if="item.subscribe == 'new'" class='bx bxs-star' style='color:#0085ff'  ></i>
              </span>
              {{index+1}}
            </td>
            <td v-for="(column, indextd) in ramData.headersV2" :key="indextd" :class="setTdClass(column)"  data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);">
              <div v-if="column.inputType == 'Combo'">
                <div v-for="(zcolumn, zindex) in column.value" :key="zindex" > 
                  <strong v-if="zcolumn.label != '' && zcolumn.label != undefined ">{{zcolumn.label+':'}}</strong> 
                  <div v-if="zcolumn.repeatable != undefined && zcolumn.repeatable == true ">
                    <span v-for="(xitem, xindex) in formatData('JSON',item[zcolumn.attributeName])" :key="xindex" >
                      <span v-for="(yitem, yindex) in zcolumn.attributes" :key="yindex">
                        <span  v-if="yitem.inputType == 'phoneNumber' ">
                          {{ formatData('phone',xitem[yitem.attributeName])}}
                        </span>
                        <span v-else>
                          {{xitem[yitem.attributeName]+ ' '}}
                        </span>
                        &nbsp;
                      </span> 
                      <br>
                    </span>
                  </div>
                  <div v-else-if="typeof formatData('JSON',item[zcolumn.attributeName]) == 'object'"  >
                    <span v-for="(dataItem, dataindex) in formatData('JSON',item[zcolumn.attributeName])" :key="dataindex" >
                      <span v-if="dataindex != 'PK' && dataindex != 'SK'">
                          {{ dataItem+ ' ' }} 
                      </span>
                    </span>
                  </div>
                  <div v-else > 
                    <span v-if="zcolumn.inputType == '' || zcolumn.inputType == 'preloadList'"> 
                      <div v-for="(zitem, zindex) in formatData('JSON',item[zcolumn.attributeName])" :key="zindex" >
                        <span v-if="zindex != 'PK' && zindex != 'SK'"> 
                          {{zitem}}
                        </span>
                      </div>
                    </span>
                    <span v-else-if="zcolumn.format == 'currency'"> 
                      <span v-if="item[zcolumn.attributeName] == '' || item[zcolumn.attributeName] == 'undefined' || item[zcolumn.attributeName] == undefined" > --.-- </span>
                      <span v-else> {{ (JSON.parse(f_itemValue(item, column.attributeName))).toLocaleString('en-US', { style: 'currency', currency: 'USD'}) }} </span>
                    </span>
                    <span v-else-if="zcolumn.format == 'Date'"> 
                      <span style="display:none;"> {{f_itemValue(item, zcolumn.attributeName)}}</span>
                      {{ formatData('date',item[zcolumn.attributeName])[0]}}  <br> {{ formatData('date',item[zcolumn.attributeName])[1]}}
                    </span>
                    <span v-else-if="zcolumn.attributeName == 'phoneNumber'"> 
                      {{ formatData('phone',item[zcolumn.attributeName])}}
                    </span>
                    <span v-else-if="zcolumn.attributeType == 'Boolean'"> 
                      <i v-if="f_itemValue(item, zcolumn.attributeName) == true" class='bx bxs-check-circle' style='color:#59d000; font-size:22px; opacity:0.6;'></i>
                    </span>
                    <span v-else> 
                      {{ f_itemValue(item, zcolumn.attributeName) }}   
                    </span>
                  </div>
                </div>
              </div>
              <div v-else-if="typeof f_itemValue(item, column.attributeName) == 'object'"  >
                <div v-for="(dataItem, dataindex) in f_itemValue(item, column.attributeName)" :key="dataindex" >
                  <span v-if="dataindex != 'PK' && dataindex != 'SK'">
                    <span v-if="typeof dataItem == 'object' " >
                      <span  v-for="(key, xindex) in dataItem" :key="xindex">
                      {{key}}
                      </span>
                    </span>
                    <span v-if="typeof dataItem == 'string'"> 
                      {{ dataItem }} 
                    </span>
                  </span>
                </div>
              </div>
              <div v-else > 
                <span v-if="column.inputType == '' || column.inputType == 'preloadList'"> 
                  <div v-for="(zitem, zindex) in formatData('JSON',item[column.attributeName])" :key="zindex" >
                    <span v-if="zindex != 'PK' && zindex != 'SK'"> 
                      {{zitem}}
                    </span>
                  </div>
                </span>
                <span v-else-if="column.format == 'currency'"> 
                  <span v-if="item[column.attributeName] == '' || item[column.attributeName] == 'undefined' || item[column.attributeName] == undefined" > --.-- </span>
                  <span v-else> {{(JSON.parse(f_itemValue(item, column.attributeName))).toLocaleString('en-US', { style: 'currency', currency: 'USD'}) }} </span>
                </span>
                <span v-else-if="column.format == 'Date'"> 
                  <span style="display:none;"> {{f_itemValue(item, column.attributeName)}}</span>
                  {{ formatData('date',item[column.attributeName])[0]}}    <br> {{ formatData('date',item[column.attributeName])[1]}}  
                </span>
                <span v-else-if="column.attributeName == 'phoneNumber'"> 
                  {{ formatData('phone',item[column.attributeName])}}  
                </span>
                <span v-else-if="column.attributeType == 'Boolean'"> 
                  <i v-if="f_itemValue(item, column.attributeName) == true" class='bx bxs-check-circle' style='color:#59d000; font-size:22px; opacity:0.6;'></i>
                </span>
                <span v-else> 
                  {{ f_itemValue(item, column.attributeName) }}   
                </span>
              </div>
            </td> 
            <td class="options-td">
              <div class="options">   
                <router-link v-if="this.pageQuery == 'MPR'"  :to="{ paht:'/posts', query:{name: 'posts', data:item.SK}}" style="cursor: pointer"  data-placement="top" target="_blank" > 
                  <div class="col send">
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16"><path fill="white" d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/></svg>
                  </div>
                </router-link>
                <div class="dropdown show" v-if="entities[dataModule['modules.dataQuery']]">
                  <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Action">
                    <ui-accion-button action="action"/>
                  </a>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <a class="dropdown-item" style="cursor: pointer; overflow:hidden;"  v-for="(action, aindex) in JSON.parse(entities[dataModule['modules.dataQuery']]['SML.descendantEntitiesWithForm'])" :key="aindex" v-on:click="setgRecord([item, 'action',aindex ]);" data-toggle="modal" data-target="#modal-update">
                      <ui-accion-button action="action"/>
                      <span v-if="action['metaEntity.descendantEntities'].SK =='#ENT#f9910928-2e9d-4e4b-9a43-19fc1ead11a1'" style="padding: 6px 0; display: block;">
                        {{action['modules.formSK'].value}}
                      </span>
                      <span v-else style="padding: 6px 0; display: block;">
                        {{action['metaEntity.descendantEntities'].value}}
                      </span>
                    </a>
                  </div>
                </div>
                <a v-if="pageQuery == 'CON'" style="cursor: pointer"  v-on:click="f_emailTemplates('list',item.PK , item.SK, item )"  data-toggle="tooltip" data-placement="top" title="Tooltip on top"> 
                  <ui-accion-button action="send"/>
                </a>
                <a style="cursor: pointer" data-toggle="modal" data-target="#modal-archive" v-on:click="getItem({sml:item.form,entity:{PK:'', SK:''},entity:{PK:'', SK:''}},item.edit, item.PK, item.SK)">
                  <ui-accion-button action="archive"/>
                </a>
                <a style="cursor: pointer" v-if="pageQuery == 'QUO'"  data-toggle="modal" data-target="#modal-send"  v-on:click="f_emailTemplates('list',item.PK , item.SK, item )">
                  <ui-accion-button action="send"/>
                </a>
                
                <router-link v-if="pageQuery == 'QUO'"  :to=" { path: '/checkout', query: { data: item.SK } }"  target="_blank" >
                  <ui-accion-button action="checkout" style="height: 35px; padding: 8px;"/>
                </router-link>
                <a style="cursor: pointer" v-on:click="setFavorite(item.PK, item.SK)" >
                  <ui-accion-button action="favorite"/>
                </a>
                <a style="cursor: pointer" v-on:click="setClone(item.PK, item.SK)" >
                  <ui-accion-button action="clone"/>
                </a>
                <a style="cursor: pointer" data-toggle="modal" data-target="#modal-active" v-on:click="getItem({sml:item.form, entity:{PK:'', SK:''}, entity:{PK:'', SK:''}},item.edit, item.PK, item.SK, undefined, 'delete')">
                  <div class="col delete">
                    <svg width="78" height="100" viewBox="0 0 78 100" fill="none" >
                      <path d="M5.57143 88.8889C5.57143 95 10.5857 100 16.7143 100H61.2857C67.4143 100 72.4286 95 72.4286 88.8889V22.2222H5.57143V88.8889ZM78 5.55556H58.5L52.9286 0H25.0714L19.5 5.55556H0V16.6667H78V5.55556Z" fill="#000" />
                    </svg>
                  </div>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <table v-else class="table" id="myTable"> 
        <thead>
          <th class="index"> New</th>
          <th v-for="(column, indexcolumns) in ramData.headers" :key="indexcolumns">
            <div class="dropdown">
              <span v-on:click="sortTable(indexcolumns+1)">
                {{ column.label }}
              </span>
              <a style="cursor:pointer;" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-if="column.filter">
                <svg  width="16" height="12" viewBox="0 0 28 24" fill="none" style="margin: 0px 0px 0px 10px; cursor:pointer;">
                  <path d="M10.8889 24L17.1111 20V13.6L28 0H0L10.8889 13.6V24Z" fill="#383838"/>
                </svg>
              </a>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuLink" v-if="column.filter">
                <div class="smart-wrap">
                    {{indexcolumns+ '-'+ valueFilter}}
                  <div class="input-wrap col-md-12" v-for="(filterItem, i) in column.filter" :key="i" >
                    {{filterItem}}
                    <input type="checkbox" :value="filterItem" v-model="valueFilter" v-on:click="filterTable(indexcolumns+1)">
                  </div>
                </div>
              </div>
            </div>
          </th>
          <th>Actions</th>
        </thead>
        <tbody v-if="pageQuery == '#SML'">
          <tr v-for="(item, index) in ramData.data.slice(pagination[1], pagination[1]+pageSize )" :key="index" :id="'tr-'+index" style="cursor:pointer;" class="tr-hover" >

            <td class="index"   v-on:click="getItem({sml:item.form, entity:{ PK:entity.PK, SK:entity.SK}}, item.edit, item.PK, item.SK , false)">
              <span v-if="item.subscribe">
                <i v-if="item.subscribe == 'edit'" class='bx bxs-pencil' style='color:#5ad911'></i>
                <i v-if="item.subscribe == 'new'" class='bx bxs-star' style='color:#0085ff'  ></i>
              </span>
              {{index+1}}
            </td>
            <td v-for="(column, indextd) in ramData.headers" :key="indextd" :class="setTdClass(column)"   v-on:click="setgRecord([item, 'update']);">
              <div v-if="typeof f_itemValue(item, column.attributeName) == 'object'"  >
                <div v-for="(dataItem, dataindex) in f_itemValue(item, column.attributeName)" :key="dataindex" >
                  <span v-if="dataindex != 'PK' && dataindex != 'SK'">
                    <span v-if="typeof dataItem == 'object' " >
                      <span  v-for="(key, xindex) in dataItem" :key="xindex">
                      {{key}}
                      </span>
                    </span>
                    <span v-if="typeof dataItem == 'string'"> 
                      {{ dataItem }} 
                    </span>
                  </span>
                </div>
              </div>
              <div v-else >
                <span v-if="column.inputType == '' || column.inputType == 'preloadList'"> 
                  <div v-for="(zitem, zindex) in formatData('JSON',  item[column.attributeName])" :key="zindex" >
                    <span v-if="zindex != 'PK' && zindex != 'SK'"> 
                      {{zitem}}
                    </span>
                  </div>
                </span>
                <span v-else-if="column.inputType == 'L'"> 
                  <span v-for="(zitem, zindex) in  formatData('JSON',item[column.attributeName])" :key="zindex">
                  {{zitem}} <br>
                  </span>
                </span>
                <span v-else-if="column.inputType == 'range' && item[column.attributeName]">
                  <div class="progress" :style="'background:'+organizationData.colorSeriesA[0]+'!important;'">
                    <div class="progress-bar bg-success" role="progressbar" :style="'width:'+ progress(item[column.attributeName])+'%; background:'+organizationData.colorSeriesA[1]+'!important;'" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">{{ progress(item[column.attributeName])}}%</div>
                  </div>
                </span>
                <span v-else-if="column.format == 'currency'"> 
                  <span v-if="item[column.attributeName] == '' || item[column.attributeName] == 'undefined' || item[column.attributeName] == undefined" > --.-- </span>
                  <span v-else> {{(JSON.parse(f_itemValue(item, column.attributeName))).toLocaleString('en-US', { style: 'currency', currency: 'USD'}) }} </span>
                </span>
                <span v-else-if="column.format == 'Date'">
                  {{ formatData('date',item[column.attributeName])[0]}}   <br> {{ formatData('date',item[column.attributeName])[1]}}
                </span>
                <span v-else-if="column.attributeName == 'phoneNumber'"> 
                  {{ formatData('phone',item[column.attributeName])}}  
                </span>
                <span v-else-if="column.attributeType == 'Boolean'"> 
                  <i v-if="f_itemValue(item, column.attributeName) == true" class='bx bxs-check-circle'  :style="'color:'+organizationData.colorSeriesA[0]+'; font-size:25px; opacity:0.9;'"></i>
                </span>
                <span v-else-if="column.attributeType == 'HTML'">
                  {{cellcellHTML('cellHTML-'+column.attributeName+'-'+index, item[column.attributeName])}}
                  <span :id="'cellHTML-'+column.attributeName+'-'+index" style="max-width: 200px; display: block;"></span> 
                </span>
                <span v-else>
                  {{ f_itemValue(item, column.attributeName) }}   
                </span>
              </div>
            </td> 
            <td class="options-td">
              <div class="options">   
                <router-link v-if="this.pageQuery == 'MPR'"  :to="{ paht:'/posts', query:{name: 'posts', data:item.SK}}" style="cursor: pointer"  data-placement="top" target="_blank" > 
                  <div class="col send">
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16"><path fill="white" d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/></svg>
                  </div>
                </router-link>
                <div class="dropdown show" v-if="entities[dataModule['modules.dataQuery']]">
                  <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Action">
                    <ui-accion-button action="action"/>
                  </a>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <a class="dropdown-item" style="cursor: pointer; overflow:hidden;"  v-for="(action, aindex) in JSON.parse(entities[dataModule['modules.dataQuery']]['SML.descendantEntitiesWithForm'])" :key="aindex" v-on:click="setgRecord([item, 'action', aindex]);" data-toggle="modal" data-target="#modal-update">
                      <ui-accion-button action="action"/>
                      <span v-if="action['metaEntity.descendantEntities'].SK =='#ENT#f9910928-2e9d-4e4b-9a43-19fc1ead11a1'" style="padding: 6px 0; display: block;">
                        {{action['modules.formSK'].value}}
                      </span>
                      <span v-else style="padding: 6px 0; display: block;">
                        {{action['metaEntity.descendantEntities'].value}}
                      </span>
                    </a>
                  </div>
                </div>
                <a v-if="pageQuery == 'CON'" style="cursor: pointer"  v-on:click="f_emailTemplates('list',item.PK , item.SK, item )"  data-toggle="tooltip" data-placement="top" title="Tooltip on top"> 
                  <ui-accion-button action="send"/>
                </a>
                <a style="cursor: pointer" data-toggle="modal" data-target="#modal-archive" v-on:click="getItem({sml:item.form,entity:{PK:'', SK:''},entity:{PK:'', SK:''}},item.edit, item.PK, item.SK)">
                  <ui-accion-button action="archive"/>
                </a>
                <a style="cursor: pointer" v-if="pageQuery == 'QUO'"  data-toggle="modal" data-target="#modal-send"  v-on:click="f_emailTemplates('list',item.PK , item.SK, item )">
                  <ui-accion-button action="send"/>
                </a>
                <a style="cursor: pointer" v-if="pageQuery == 'PHO' || pageQuery== 'PHC'"  data-toggle="modal" data-target="#modal-sms"  v-on:click="msmActions('init', item);">
                  <ui-accion-button action="sms"/>
                </a>
                <router-link v-if="pageQuery == 'QUO'"  :to=" { path: '/checkout', query: { data: item.SK } }"  target="_blank" >
                  <ui-accion-button action="checkout" style="height: 35px; padding: 8px;"/>
                </router-link>
                <a style="cursor: pointer" v-on:click="setFavorite(item.PK, item.SK)" >
                  <ui-accion-button action="favorite"/>
                </a>
                <a style="cursor: pointer" v-on:click="setClone(item.PK, item.SK)" >
                  <ui-accion-button action="clone"/>
                </a>
                <a style="cursor: pointer" data-toggle="modal" data-target="#modal-active" v-on:click="getItem({sml:item.form, entity:{PK:'', SK:''}, entity:{PK:'', SK:''}},item.edit, item.PK, item.SK, undefined, 'delete')">
                  <div class="col delete">
                    <svg width="78" height="100" viewBox="0 0 78 100" fill="none" >
                      <path d="M5.57143 88.8889C5.57143 95 10.5857 100 16.7143 100H61.2857C67.4143 100 72.4286 95 72.4286 88.8889V22.2222H5.57143V88.8889ZM78 5.55556H58.5L52.9286 0H25.0714L19.5 5.55556H0V16.6667H78V5.55556Z" fill="#000" />
                    </svg>
                  </div>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-for="(item, index) in ramData.data.slice(pagination[1], pagination[1]+pageSize )" :key="index" :id="'tr-'+index" style="cursor:pointer;" class="tr-hover" >

            <td class="index"  data-toggle="modal" data-target="#modal-update" v-on:click="getItem({sml:item.form, entity:{ PK:entity.PK, SK:entity.SK}}, item.edit, item.PK, item.SK , false)">
              <span v-if="item.subscribe">
                <i v-if="item.subscribe == 'edit'" class='bx bxs-pencil' style='color:#5ad911'></i>
                <i v-if="item.subscribe == 'new'" class='bx bxs-star' style='color:#0085ff'  ></i>
              </span>
              {{index+1}}
            </td>
            <td v-for="(column, indextd) in ramData.headers" :key="indextd" :class="setTdClass(column)"  data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);">
              <div v-if="typeof f_itemValue(item, column.attributeName) == 'object'"  >
                <div v-for="(dataItem, dataindex) in f_itemValue(item, column.attributeName)" :key="dataindex" >
                  <span v-if="dataindex != 'PK' && dataindex != 'SK'">
                    <span v-if="typeof dataItem == 'object' " >
                      <span  v-for="(key, xindex) in dataItem" :key="xindex">
                      {{key}}
                      </span>
                    </span>
                    <span v-if="typeof dataItem == 'string'"> 
                      {{ dataItem }} 
                    </span>
                  </span>
                </div>
              </div>
              <div v-else >
                <span v-if="column.inputType == '' || column.inputType == 'preloadList'"> 
                  <div v-for="(zitem, zindex) in formatData('JSON',  item[column.attributeName])" :key="zindex" >
                    <span v-if="zindex != 'PK' && zindex != 'SK'"> 
                      {{zitem}}
                    </span>
                  </div>
                </span>
                <span v-else-if="column.inputType == 'L'"> 
                  <span v-for="(zitem, zindex) in  formatData('JSON',item[column.attributeName])" :key="zindex">
                  {{zitem}} <br>
                  </span>
                </span>
                <span v-else-if="column.inputType == 'range' && item[column.attributeName]">
                  <div class="progress" :style="'background:'+organizationData.colorSeriesA[0]+'!important;'">
                    <div class="progress-bar bg-success" role="progressbar" :style="'width:'+ progress(item[column.attributeName])+'%; background:'+organizationData.colorSeriesA[1]+'!important;'" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">{{ progress(item[column.attributeName])}}%</div>
                  </div>
                </span>
                <span v-else-if="column.format == 'currency'"> 
                  <span v-if="item[column.attributeName] == '' || item[column.attributeName] == 'undefined' || item[column.attributeName] == undefined" > --.-- </span>
                  <span v-else> {{(JSON.parse(f_itemValue(item, column.attributeName))).toLocaleString('en-US', { style: 'currency', currency: 'USD'}) }} </span>
                </span>
                <span v-else-if="column.format == 'Date'">
                  {{ formatData('date',item[column.attributeName])[0]}}   <br> {{ formatData('date',item[column.attributeName])[1]}}
                </span>
                <span v-else-if="column.attributeName == 'phoneNumber'"> 
                  {{ formatData('phone',item[column.attributeName])}}  
                </span>
                <span v-else-if="column.attributeType == 'Boolean'"> 
                  <i v-if="f_itemValue(item, column.attributeName) == true" class='bx bxs-check-circle'  :style="'color:'+organizationData.colorSeriesA[0]+'; font-size:25px; opacity:0.9;'"></i>
                </span>
                <span v-else-if="column.attributeType == 'HTML'">
                  {{cellcellHTML('cellHTML-'+column.attributeName+'-'+index, item[column.attributeName])}}
                  <span :id="'cellHTML-'+column.attributeName+'-'+index" style="max-width: 200px; display: block;"></span> 
                </span>
                <span v-else>
                  {{ f_itemValue(item, column.attributeName) }}   
                </span>
              </div>
            </td> 
            <td class="options-td">
              <div class="options">   
                <router-link v-if="this.pageQuery == 'MPR'"  :to="{ paht:'/posts', query:{name: 'posts', data:item.SK}}" style="cursor: pointer"  data-placement="top" target="_blank" > 
                  <div class="col send">
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16"><path fill="white" d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/></svg>
                  </div>
                </router-link>
                <div class="dropdown show" v-if="entities[dataModule['modules.dataQuery']]">
                  <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Action">
                    <ui-accion-button action="action"/>
                  </a>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <a class="dropdown-item" style="cursor: pointer; overflow:hidden;"  v-for="(action, aindex) in JSON.parse(entities[dataModule['modules.dataQuery']]['SML.descendantEntitiesWithForm'])" :key="aindex" v-on:click="setgRecord([item, 'action', aindex]);" data-toggle="modal" data-target="#modal-update">
                      <ui-accion-button action="action"/>
                      <span v-if="action['metaEntity.descendantEntities'].SK =='#ENT#f9910928-2e9d-4e4b-9a43-19fc1ead11a1'" style="padding: 6px 0; display: block;">
                        {{action['modules.formSK'].value}}
                      </span>
                      <span v-else style="padding: 6px 0; display: block;">
                        {{action['metaEntity.descendantEntities'].value}}
                      </span>
                    </a>
                  </div>
                </div>
                <a v-if="pageQuery == 'CON'" style="cursor: pointer"  v-on:click="f_emailTemplates('list',item.PK , item.SK, item )"  data-toggle="tooltip" data-placement="top" title="Tooltip on top"> 
                  <ui-accion-button action="send"/>
                </a>
                <a style="cursor: pointer" data-toggle="modal" data-target="#modal-archive" v-on:click="getItem({sml:item.form,entity:{PK:'', SK:''},entity:{PK:'', SK:''}},item.edit, item.PK, item.SK)">
                  <ui-accion-button action="archive"/>
                </a>
                <a style="cursor: pointer" v-if="pageQuery == 'QUO'"  data-toggle="modal" data-target="#modal-send"  v-on:click="f_emailTemplates('list',item.PK , item.SK, item )">
                  <ui-accion-button action="send"/>
                </a>
                <a style="cursor: pointer" v-if="pageQuery == 'PHO' || pageQuery== 'PHC'"  data-toggle="modal" data-target="#modal-sms"  v-on:click="msmActions('init', item);">
                  <ui-accion-button action="sms"/>
                </a>
                <router-link v-if="pageQuery == 'QUO'"  :to=" { path: '/checkout', query: { data: item.SK } }"  target="_blank" >
                  <ui-accion-button action="checkout" style="height: 35px; padding: 8px;"/>
                </router-link>
                <a style="cursor: pointer" v-on:click="setFavorite(item.PK, item.SK)" >
                  <ui-accion-button action="favorite"/>
                </a>
                <a style="cursor: pointer" v-on:click="setClone(item.PK, item.SK)" >
                  <ui-accion-button action="clone"/>
                </a>
                <a style="cursor: pointer" data-toggle="modal" data-target="#modal-active" v-on:click="getItem({sml:item.form, entity:{PK:'', SK:''}, entity:{PK:'', SK:''}},item.edit, item.PK, item.SK, undefined, 'delete')">
                  <div class="col delete">
                    <svg width="78" height="100" viewBox="0 0 78 100" fill="none" >
                      <path d="M5.57143 88.8889C5.57143 95 10.5857 100 16.7143 100H61.2857C67.4143 100 72.4286 95 72.4286 88.8889V22.2222H5.57143V88.8889ZM78 5.55556H58.5L52.9286 0H25.0714L19.5 5.55556H0V16.6667H78V5.55556Z" fill="#000" />
                    </svg>
                  </div>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="element-wrap col-md-12">
      <div class="pagination" style="font-size: 20px;display: block;">
        <i class='bx bxs-left-arrow' v-if="lastEvaluatedKey != undefined" v-on:click="f_ListDataSet(true)"></i>
        <i class='bx bxs-right-arrow'  v-if="lastEvaluatedKey != undefined" v-on:click="f_ListDataSet()" > </i>
      </div>
    </div>
  </div>
  <!--Modal Edit-->
  <ui-modal name="updateOld" type="update" >
    <template #content>
      <div class="smart-wrap">
          <div class="wrap-title col-md-5">
            <h2  class="title-g">{{layoutName}}</h2>
            <p v-if=" itemSK != undefined && itemView.friendlyId != undefined" class="infoItem" data-toggle="collapse" href="#infoItem" role="button" aria-expanded="false" aria-controls="infoItem">{{itemView.PK}}: {{ itemView.entityName+ '-'+ itemView.friendlyId}}</p>
            <p v-if=" itemSK != undefined && itemView.friendlyId == undefined" class="infoItem" data-toggle="collapse" href="#infoItem" role="button" aria-expanded="false" aria-controls="infoItem">{{itemView.PK}}</p>
            <p v-if=" itemSK == undefined" class="infoItem" data-toggle="collapse" href="#infoItem" role="button" aria-expanded="false" aria-controls="infoItem">{{systemType}}: (New Item)</p>
            <div v-if="userPermissions.includes('Superadmin') || userPermissions.includes('Admin')" class="collapse" id="infoItem">
              <div class="card card-body">
                <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>PK: </strong> {{itemPK}}</p>
                <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>SK: </strong> {{itemSK}}</p>
                <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>Active: </strong> {{itemView.active}}</p>
                <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>Parent: </strong> {{itemView.parent}}</p>
                <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>EntityItem: </strong> {{itemView.entity}}</p>
                <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>Form: </strong> {{itemView.form}}</p>
                <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>Created By </strong> {{itemView.createdBy}}</p>
                <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>Created At: </strong> {{itemView.createdAt}}</p>
                <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>Updated At: </strong> {{itemView.updatedAt}}</p>
                <p style="color: #949494; margin:0; font-size: 12px; padding: 0;"> <strong>GSP1PK1: </strong> {{itemView.GSP1PK1}}</p>
              </div>
            </div>
          </div>
          <div class="col wrap-button col-md-7">
            <ui-button :style="'background:'+organizationData.colorSeriesA[0]+';'" :color="'gray'" :text="'X'" :position="'right'" data-dismiss="modal" style="margin: 0 0 0 10px;" />
            <span v-if=" mode == 'edit'">
              <ui-button :style="'background:'+organizationData.colorSeriesA[1]+'; margin: 0 0 0 10px;'" :color="'green'" :text="'Save and Close'" :position="'right'" :id="'saveClose-'+itemSK" data-dismiss="modal"  v-on:click="loading('show');f_updateRecord(itemSK, models);" />
              <ui-button :style="'background:'+organizationData.colorSeriesA[2]+'; margin: 0 0 0 10px;'" :color="'green'" :text="'Save'" :position="'right'" :id="'save-'+itemSK" v-on:click=" loading('show'); f_updateRecord(itemSK, models);" >
                <i class='bx bxs-save'></i>
              </ui-button>
            </span>
            <span v-else>
              <ui-button :style="'background:'+organizationData.colorSeriesA[1]+'; margin: 0 0 0 10px;'" :color="'green'" :text="'Save and Close'" :position="'right'" data-dismiss="modal" v-on:click="loading('show'); f_updateRecord(undefined, models)"/>
              <ui-button :style="'background:'+organizationData.colorSeriesA[2]+'; margin: 0 0 0 10px;'" :color="'green'" :text="'Save'" :position="'right'" v-on:click="loading('show'); f_updateRecord(undefined, models)">
                <i class='bx bxs-save'></i>
              </ui-button>
            </span>
            <span class="col-md-12" v-if="itemPK && itemSK && pageQuery != '#ORG'">
              <ui-button  v-if="itemSK.startsWith('QUO')" :style="'background:'+organizationData.colorSeriesA[3]+'; margin: 0 0 0 10px; height: 44px;'" :color="'green'" :text="''" :position="'right'">
                <router-link  :to=" { path: '/checkout', query: { data:itemSK,  } }"  target="_blank" >
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24 7.5V18.75C24 19.9875 23.0182 21 21.8182 21H4.36364C3.76364 21 3.27273 20.4938 3.27273 19.875C3.27273 19.2562 3.76364 18.75 4.36364 18.75H21.8182V7.5C21.8182 6.88125 22.3091 6.375 22.9091 6.375C23.5091 6.375 24 6.88125 24 7.5ZM3.27273 16.5C1.46182 16.5 0 14.9925 0 13.125V6.375C0 4.5075 1.46182 3 3.27273 3H16.3636C18.1745 3 19.6364 4.5075 19.6364 6.375V14.25C19.6364 15.4875 18.6545 16.5 17.4545 16.5H3.27273ZM6.54545 9.75C6.54545 11.6175 8.00727 13.125 9.81818 13.125C11.6291 13.125 13.0909 11.6175 13.0909 9.75C13.0909 7.8825 11.6291 6.375 9.81818 6.375C8.00727 6.375 6.54545 7.8825 6.54545 9.75Z" fill="white"/>
                  </svg>
                </router-link>
              </ui-button>
            </span>
            <span class="col-md-12" v-if="itemPK && itemSK && pageQuery != '#ORG'">
              <ui-button  v-if="itemSK.startsWith('QUO')" :style="'background:'+organizationData.colorSeriesA[4]+'; margin: 0 0 0 10px; height: 44px;'" :color="'blue'" :text="''" :position="'right'" data-toggle="modal" data-target="#modal-send"  v-on:click="f_emailTemplates('editorQuote',itemPK , itemSK, )">
                <svg width="30" height="30" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M34 4.01237C33.8493 3.99588 33.6974 3.99588 33.5466 4.01237H2.58604C2.38761 4.01561 2.19049 4.0472 2 4.10629L17.9779 21L34 4.01237Z" fill="white"/>
                  <path d="M35.865 6L19.485 22.674C19.0634 23.1024 18.4932 23.3428 17.8987 23.3428C17.3043 23.3428 16.7341 23.1024 16.3125 22.674L0.0787501 6.12649C0.0288444 6.31398 0.00238352 6.50717 0 6.70146V29.7001C0 30.3101 0.237053 30.8951 0.65901 31.3264C1.08097 31.7577 1.65326 32 2.25 32H33.75C34.3467 32 34.919 31.7577 35.341 31.3264C35.7629 30.8951 36 30.3101 36 29.7001V6.70146C35.991 6.46188 35.9455 6.2252 35.865 6V6ZM3.79125 29.7001H2.2275V28.0557L10.4062 19.7647L11.9925 21.3861L3.79125 29.7001ZM33.7275 29.7001H32.1525L23.9512 21.3861L25.5375 19.7647L33.7162 28.0557L33.7275 29.7001Z" fill="white"/>
                </svg>
              </ui-button>
            </span>
          
          </div>
        </div>
        <!-- Modal body-->
        <br>
        <div class="smart-wrap ">
          <div v-if="recordSub == true" class="col wrap-button col-md-12">
              <div style="width: 400px; margin:0 auto; text-align:center; display:block; background:#ccc; overflow:hidden;">
                <br>
                <h4>username has just updated this record.</h4>
                <h6>If you accept changes, your changes will be lost. <br> Accept changes?</h6>
                <ui-button style="margin:20px; width: 160px; float:left;" :color="'blue'" :text="'Yes'" :position="'center'"  v-on:click="getItem({sml:itemView.form, entity:{ PK:itemView.entity.PK, SK:itemView.entity.SK}}, itemView.edit, itemView.PK, itemView.SK , false) ; setRecordSub(false)"/>
                <ui-button style="margin:20px; width: 160px; float:left;" :color="'gray'" :text="'No'" :position="'center'" v-on:click="sub = false" />
              </div>
            </div>
          <div  v-if="dataModule.allowSelectPK == true && userPermissions.includes('Superadmin') " class="input-wrap col-md-6">
            <div v-if="userPermissions.includes('Superadmin') || userPermissions.includes('Admin')">
              <label for="">PK</label>
              <select name="" id=""  v-model="systemType" v-on:change="listDataSet(true)">
                <option selected disabled hidden>select an option</option>
                <option value="#SMARTDASH">System</option>
                <option :value="item.value" v-for="(item, index) in preloadLists['#ORG']" :key="index">
                  {{ item.value.replace("ORG#", "") }}
                </option>
              </select>
            </div>
            <div v-else>
              <label for="">PK</label>
              <select name="" id=""  v-model="systemType" v-on:change="listDataSet(true)">
                <option selected disabled hidden>select an option</option>
                <option value="#SMARTDASH">System</option>
                <option :value="organizationID">
                  {{ organizationID.replace("ORG#", "") }}
                </option>
              </select>
            </div>
          </div>
          <div v-if="layoutCategory == 'smartForm'" class="input-wrap">
            <label for="">Filter Smart Form </label>
            <select name="" id="" v-model="filterSmarForm">
              <option value="complete"> Complete</option>
              <option value="incomplete">Incomplete</option>
              <option value="all">All</option>
            </select>
          </div>

          <paper-layout id="layout" :layoutCategory="layoutCategory" :filterSmarForm="filterSmarForm" :data="{PK:itemPK,SK:itemSK}" :layout="layout" :models="models" :parent="parent" :paperPermissions="{usersCanEdit:usersCanEdit, usersCanRead:usersCanRead,groupsCanEdit:groupsCanEdit,groupsCanRead:groupsCanRead}"/>
          <div v-if="userPermissions.includes('Superadmin') || userPermissions.includes('Admin') " class="row form-row col-md-12" style="background:#ccc; padding:20px; margin:20px 0 0 0;">
            <div class="col col-md-3" >
              <div class="check" >
                <label for="" style="font-weight: 600;">Groups Can Edit</label>
                <div class="envelop permissions" v-for="(check, zindex) in permissions" :key="zindex">
                  <input type="checkbox" class="box" :value="check.value" v-model="groupsCanEdit"/>
                  <span class="text" > {{check.value}} </span>
                </div>
              </div>
            </div>
            <div class="col col-md-3" >
              <div class="check" >
                <label for="" style="font-weight: 600;">Groups Can Read</label>
                <div class="envelop permissions" v-for="(check, zindex) in permissions" :key="zindex">
                  <input type="checkbox" class="box" :value="check.value" v-model="groupsCanRead"/>
                  <span class="text" > {{check.value}} </span>
                </div>
              </div>
            </div>
            <div class="col col-md-3" >
              <div class="check" >
                <label for="" style="font-weight: 600;">User Can Edit</label>
                <div class="envelop permissions">
                  <input type="checkbox" class="box" value="@author" v-model="usersCanEdit"/>
                  <span class="text" > @Author </span>
                </div>
                <div class="envelop permissions">
                  <input type="checkbox" class="box" value="@client" v-model="usersCanEdit"/>
                  <span class="text" > @Client </span>
                </div>
                <div class="envelop permissions" >
                  <input type="checkbox" class="box" value="@responsible" v-model="usersCanEdit"/>
                  <span class="text" > @Responsible </span>
                </div>
              </div>
            </div>
            <div class="col col-md-3" >
              <div class="check" >
                <label for="" style="font-weight: 600;">User Can Read</label>
                <div class="envelop permissions">
                  <input type="checkbox" class="box" value="@author" v-model="usersCanRead"/>
                  <span class="text" > @Author </span>
                </div>
                <div class="envelop permissions">
                  <input type="checkbox" class="box" value="@client" v-model="usersCanRead"/>
                  <span class="text" > @Client </span>
                </div>
                <div class="envelop permissions" >
                  <input type="checkbox" class="box" value="@responsible" v-model="usersCanRead"/>
                  <span class="text" > @Responsible </span>
                </div>
              </div>
            </div>
          </div>
        </div>
    </template>
  </ui-modal>
  <!--Modal Active-->
  <div id="modal-active" class="modal fade modal-default" role="dialog">
    <div class="modal-dialog delete" style="">
      <!-- Modal content-->
      <div class="modal-content">
        <!-- Modal buttons--> 
        <div class="wrap-head">
          <div class="row">
            <div class="col wrap-title">
              <h5 class="title-g">
                Delete item {{ itemView.entityName + " - " + itemView.friendlyId }} ?
              </h5>
            </div>
            <div class="col wrap-button">
              <ui-button style="margin: 0 0 0 10px;" :color="'red'" :text="'Cancel'" :position="'right'" data-dismiss="modal" />
              <ui-button v-if="activeStatus == '1'" style="margin: 0 0 0 10px;" :color="'green'" :text="'Confirm'" :position="'right'" data-dismiss="modal" v-on:click="setStatus(itemPK, itemSK, 'desactive')"/>
              <ui-button v-if="activeStatus == '0'" style="margin: 0 0 0 10px;" :color="'green'" :text="'Confirm'" :position="'right'" data-dismiss="modal" v-on:click="setStatus(itemPK, itemSK, 'active')"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Modal preview-->
  <div id="modal-preview" class="modal fade modal-default" role="dialog" v-if="pageQuery != '#ORG'">
    <div class="modal-dialog delete" style="background: #fff;">
      <!-- Modal content-->
      <div class="modal-content" >
        <!-- Modal buttons--> 
        <div class="smart-wrap " style="background: #fff; padding: 0 0 40px 0;"  v-if="itemPK && itemSK">
          <div class="col-md-4 wrap-title">
            <h4 class="title-g">
              Preview 
            </h4>
          </div>
          <div class="col-md-8 wrap-button" >
            <ui-button style="margin: 0 0 0 10px;" :color="'red'" :text="'Cancel'" :position="'right'" v-on:click="closeInternalModal('preview')"/>
            <ui-button style="margin: 0 0 0 10px;" :color="'blue'" :text="'Export As PDF'" :position="'right'" v-on:click="exportAs('pdf', entityView.SK )"/>
          </div>
        </div>
        <!-- Modal body-->
        <div class="smart-wrap" id="layout-preview" v-if="entityView" style="background: #fff;">
          <div class="col-md-8">
            <h2>{{entityView.attributes[0].attributeValue}} </h2>
            <p>{{itemSK}}</p>
          </div>
          <div class="col-md-4">
            <img src="data:image/jpeg;base64,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" alt="" style="width: 100%;">
          </div>
          <paper-preview :data="{PK:itemPK,SK:itemSK, entity:item.entity }" :layout="layout" :models="models" :parent="parent" :paperPermissions="{usersCanEdit:usersCanEdit, usersCanRead:usersCanRead,groupsCanEdit:groupsCanEdit,groupsCanRead:groupsCanRead}"/>
        </div>
      </div>
    </div>
  </div>
  <!--Modal Archive-->
  <div id="modal-archive" class="modal fade modal-default" role="dialog">
    <div class="modal-dialog delete" style="">
      <!-- Modal content-->
      <div class="modal-content">
        <!-- Modal buttons--> 
        <div class="wrap-head">
          <div class="row">
            <div class="col wrap-title">
              <h4 class="title-g">
                File item {{ itemView.entityName + " - " + itemView.friendlyId }} ?
              </h4>
            </div>
            <div class="col wrap-button">
              <ui-button style="margin: 0 0 0 10px;" :color="'red'" :text="'Cancel'" :position="'right'" data-dismiss="modal"/>
              <ui-button style="margin: 0 0 0 10px;" :color="'green'" :text="'Confirm'" :position="'right'" data-dismiss="modal"  v-on:click="setStatus(itemPK, itemSK, 'archive')"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Modal Send-->
  <div id="modal-send" class="modal fade modal-default" role="dialog">
    <div class="modal-dialog" style="">
      <!-- Modal content-->
      <div class="modal-content">
        <!-- Modal buttons--> 
        <div class="wrap-head">
          <div class="row">
            <div class="col wrap-title">
              <h4 class="title-g">
                Send Email
              </h4>
              <span><strong>PK: </strong>{{itemPK}}</span><br>
              <span><strong>SK: </strong>{{itemSK}}</span>
            </div>
            <div class="col wrap-button">
              <ui-button style="margin: 0 0 0 10px;" :color="'red'" :text="'Cancel'" :position="'right'" data-dismiss="modal"/>
              <ui-button style="margin: 0 0 0 10px;" :color="'green'" :text="'Send'" :position="'right'" data-dismiss="modal" v-on:click="f_emailTemplates('send')"/>
            </div>
          </div>
        </div>
        <br>
        <div class="wrap-content row">
          <div class="col-md-3">
            <h6>Select Template</h6>
            <div class="smart-wrap">
              <div class="input-wrap">
                <label for="">Search Template</label>
                <input type="text" id="search-emailTemplates" v-on:keyup="searchItems('search-emailTemplates', 'emailTemplates' )">
              </div>
            </div>
            <div class="list-group" id="emailTemplates">
              <a style="cursor:pointer;" v-on:click="f_emailTemplates('set', emailTemplate.PK,emailTemplate.SK) " class="list-group-item list-group-item-action" v-for="(emailTemplate, eindex) in emailTemplates" :key="eindex">
                {{emailTemplate.attributes['emailTemplate.name'].value}}
              </a>
            </div>
          </div>
          <div class="list-group col-md-9">
            <form class="smart-wrap">
              <div class="row form-row" style="margin: 0 0 10px 0!important;">  
                <div class="col col-md-12">
                  <div class="input-wrap">
                    <label for="">To</label>
                    <input class="form-control" type="email" id="myInput"  title="Type in a name"  v-model="toEmail" />
                  </div>
                </div>
                <br>
                <br>
                <br>
                <div class="col col-md-12">
                  <div class="input-wrap">
                    <label for="">Subject</label>
                    <input class="form-control" type="email" id="myInput"  title="Type in a name" v-model="subjectEmail"  />
                  </div>
                </div>
                <br>
                <br>
                <br>
                <div class="col col-md-12">
                  <div class="input-wrap">
                    <span style="font-size:0; position: absolute;"> {{setEditor(itemSK)}}</span>
                    <div :id="'editor'+itemSK" v-on:keyup="setDataEditor"></div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Modal Sms-->
  <ui-modal name="sms" type="sms" classModal="modal-dialog-centered" >
    <template #content v-if="dataSMS != undefined">
      <div class="wrap-head">
        <div class="row">
          <div class="col wrap-title" v-if="dataSMS.phone != undefined">
            <h4 class="title-g"> Send SMS </h4>
            {{formatData( 'phone' ,dataSMS.phone.replace('PHO#', ''))}}
          </div>
          <div class="col wrap-button">
            <ui-button style="margin: 0 0 0 10px;" :color="'red'" :text="'Cancel'" :position="'right'" data-dismiss="modal"/>
            <ui-button style="margin: 0 0 0 10px;" :color="'green'" :text="'Send'" :position="'right'" data-dismiss="modal" v-on:click="msmActions('send', dataSMS)"/>
          </div>
        </div>
      </div>  
      <div class="smart-wrap">
        <div class="input-wrap col-12">
          <label v-if=" dataSMS.options.length != 0" for="">Options</label>
            <div class="envelop" v-show="option['phone.verified'] == true"  v-for="(option, zindex) in dataSMS.options" :key="zindex">
              <input type="radio" class="check input" :value="'PHO#'+option.phoneNumber" v-model="dataSMS.phone" /> 
              <span class="check text" > {{ formatData('phone',option.phoneNumber)}} </span>
            </div>
        </div>
        <div class="input-wrap col-12">
          <label for="">Message</label>
          <textarea name="" id="" cols="30" rows="10" v-model="dataSMS.message"></textarea>
        </div>
      </div>
    </template>
  </ui-modal>
</template>
<script>

//AWS - GRAPHQL
import { smd_listPAGWithData,smd_listEntityObj, smd_getSMLItem, smd_composeEmailTemplate, smd_getRootDataSet, smd_getRecordObj, smd_getRootPhonesEmails, smd_listPAGWithData2  } from '../../graphql/queries'
import { smd_updateSmartRecord, smd_setItemState, smd_sendEmail2, smd_addToFavorites, smd_cloneSmartRecord, smd_sendSMS } from '../../graphql/mutations'
import { onUpdateSmartRecord, onSetItemState ,onCloneItem,onCreateLead } from '../../graphql/subscriptions'

//Tools
import Vuex from 'vuex'
import { API, Storage } from 'aws-amplify'
import Swal from 'sweetalert2'
import { formatData, processBinds } from '../../store/tools.js';
//import { v4 as uuidv4 } from 'uuid';

//Components
import PaperLayout from './PaperLayout.vue'
import PaperPreview from './PaperPreview.vue'
import PaperDisplayer from './PaperDisplayer.vue'
import paperPermissions from './PaperPermissions.vue'
import UiButton from '../ui/UiButton.vue'
import UiRecursiveDisplay from '../ui/UiRecursiveDisplay.vue'
import UiAccionButton from '../ui/UiAccionButton.vue'
import UiModal from '../ui/UiModal.vue'

import trumbowyg  from 'trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'

export default {
  name: "paper-table",
  components:{
    paperPermissions,
    PaperLayout,
    PaperDisplayer,
    PaperPreview,
    UiButton,
    UiRecursiveDisplay,
    UiAccionButton,
    UiModal
  },
  data() {
    return {
      //Permis
      dataEditor:'',
      edit: false,
      read: false,
      file: "undefined",
      w_updateItemV1: [], //Temporary data of the item to edit
      //Layout
      layout: [ ], // Layout
      models: [],
      //modelsStr: [],
      parent:'general',
      // Data for Item Edition
      itemPK:"",
      itemSK:"",
      item:"",
      entityView:"",
      cretedBy:"",
      usersCanEdit:[],
      usersCanRead:[],
      groupsCanEdit:["Admin","Superadmin","Editor"],
      groupsCanRead:["Admin","Superadmin","Editor"],        
      responsable:"",
      systemType:"", // Sistem or Organization
      mode: "", // Mode for modal (New and Edit)
      v: true,
      fileURL: "",
      displayCurrency: {
        locale: 'en-US',
        currency: 'USD',
        currencyDisplay: 'symbol',
        valueRange: undefined,
        precision: undefined,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: false,
        exportValueAsInteger: false,
        autoSign: true,
        useGrouping: true
      },
      value: 1234 ,
      valuew: 1234 ,
      itemView:'',
      layoutName: 'undefined', //Layout Name
      smlView:[],
      //Table functionality
      ramData:{data:[], headers:[]},
      pagination: [10, 0],
      pageSize: 30 , //Numer of rows
      //--filtro
      statusFilter: 'All' , //Numer of rows
      dateFilter: 'none',
      rangeFilter: 'This Month' ,
      statusTableFilter: '',

      valueFilter: [],
      filter: '',
      dataHistory: '',
      activeStatus: "1", //for filtering active records or inactive record
      v_search: "", // Text Search
      helpC:true, //Estatus of Help
      w_null: true, //Number of combos
      w_fileData: [],
      lastEvaluatedKey: null,//
      //file: "undefined",
      parentItem: null,
      shortEntityItem: null,
      entityItem: {},


      // Defualt Data of Table
      entityTable: '',
      
      formVersion:"",//PENDING
      valueList: {}, //PENDING
      tmpo: { description: "" }, //PENDING
      w_updateItemV2: [], //PENDING
      dataVersion: "",//PENDINGoverfl ow: auto;

      //Email
      emailTemplates:[],
      subjectEmail:[],
      toEmail:[],

      //filterSmarForm
      filterSmarForm: 'all',
      layoutCategory: '',

      //dataSMS
      dataSMS:{
        options:[]
      },
    };
  },
  created() {
    try {
      console.clear()
      console.log(this.dataModule['modules.dataQuery']);
      console.log(this.entities);
      if (this.entities[this.dataModule['modules.dataQuery']].defaultStatus == undefined) {
        this.statusFilter = 'All'
        this.setFilterData(['statusFilter',this.statusFilter])
      }else{
        this.statusFilter = this.entities[this.dataModule['modules.dataQuery']].defaultStatus
        this.setFilterData(['statusFilter',this.statusFilter])
      }
      if (this.dataModule.allowSelectPK == true) {
        this.systemType = '#SMARTDASH'
      }else{
        this.systemType = this.organizationID
      }
      if (this.$router.currentRoute.value.query.name == 'blank') {
        this.blank('edit-'+this.$router.currentRoute.value.query.data);
      }
      if (this.dataModule.preload == true ) {
        console.log(this.recordLists);
        this.ramData.data = this.recordLists[this.pageQuery].list
        this.ramData.headers = this.recordLists[this.pageQuery].headers
        this.ramData.headersV2 = this.recordLists[this.pageQuery].headersV2
        //this.ramData.data = this.recordLists[this.pageQuery]
      }else{
        this.pageSize = this.dataUser.rows.value
        this.valueFilter = []
        this.listDataSet();
      }
      this.setItemsTable();
      this.subscribe();
      $('#loading').click(function (e) {
        if (e.shiftKey) {
          document.getElementById("loading").classList.remove('show')
          document.getElementById("body").classList.remove("noScroll")
        } 
      });   
    } catch (error) {
      this.statusFilter = 'All'
      console.log(error);
    }
  },
  methods: {
    //Vuex
    ...Vuex.mapMutations(["SetRows","setRecordLists",'updateRecordLists','setFilterData','setNotifications','setRecordSub', "setgRecord"]),
    ...Vuex.mapActions(["getRecordLists"]),
    //Tools
    cellcellHTML(name, data){
      setTimeout(() => {
        document.getElementById(name).innerHTML = data
      }, 200);
    },
    progress(data){
      return parseInt(data.replace(/"/gi, ""))
    },
    blanckPage(item){
      //let routeData = 
    
      this.$router.push({ paht:'/dashboard', query:{ name: 'clietDash', data: item.GSP1PK1 }}); 
      let forceUpdate = document.getElementById('forceUpdate')
      console.log(forceUpdate);
      var event = new Event('click');
      setTimeout(() => {
        forceUpdate.dispatchEvent(event);
        console.log(event);
      }, 100);
      //window.open(routeData.href);
    },
    formatData(format, data){
      return formatData(format, data)
    },
    goodFormat(data, format){
      let vdata = ''
      try {        
        switch (format) {
          case 'string':
            if (typeof data =='string' ) {
              vdata = JSON.parse(JSON.stringify(data, null,4))
            }else{
              vdata = JSON.stringify(data, null,4)
            }
          break;
          case 'json':
            if (typeof data =='string' ) {
              vdata = JSON.parse(data, null,4)
            }else{
              vdata =JSON.parse(JSON.stringify(data))
            }
          break;
        }
        return vdata
      } catch (error) {
        console.log('-->Good Format Error: '+format+'\n', data);
      }
    },
    loading(action, origin){
      //console.log('loading table: '+action+' - '+ origin);
      if (action == 'show') {
        document.getElementById("loading").classList.add('show')
        document.getElementById("body").classList.add("noScroll")
      }else{
        document.getElementById("loading").classList.remove('show')
        document.getElementById("body").classList.remove("noScroll")
      }
    },
    checkPermissons(data){
      let record = data
      record.edit = false
      record.read = false
      for (let index = 0; index < this.userPermissions.length; index++) {
        const element = this.userPermissions[index];
        try {
          if ( record.groupsCanEdit.includes(element)) {
            record.edit = true
          }
          if ( record.groupsCanRead.includes(element)) {
            record.read = true
          }
        } catch (error) {
          console.log(error)
        }
      }
      if ( record.usersCanRead.includes('@author')) {
        if ( record.createdBy == this.user) {
          record.edit = true
          record.read = true
        }
      }
      if (this.userPermissions.includes('Superadmin') || this.userPermissions.includes('Admin') || record.groupsCanEdit.includes('Public')) {
        record.edit = true
        record.read = true
      }
      return record
    },
    statusCode(data){
      Swal.fire({
        icon: 'warning',
        title: 'Code: '+ data.statusCode ,
        text: data.userMessage,
        footer: data.message,
      })
    },
    // Subscriptions ------------
    subscribe() { 
      console.log('Subscription ------------------------');
      API.graphql({ query: onUpdateSmartRecord }).subscribe({
        next: (eventData) => {
          let pullData = eventData.value.data.onUpdateSmartRecord;
          let data = JSON.parse(pullData.data)
          if (data.PK == this.organizationID ) {
            
            console.log('** NEW SUB: '+ data.shortEntity ,data);
            if (this.dataModule.allowSelectPK != true) {
              this.updateRecordLists(this.checkPermissons(data))
            } else {
              this.updateRecordLists(this.checkPermissons(data))
            }
            setTimeout(() => {
              if (data.shortEntity == 'NOT') {
                this.setNotifications({action:'init'})
              }
            }, 1000);
          }else{
            if (data.PK == '#SMARTDASH' && this.userPermissions.includes('Superadmin')) {
              console.log('** NEW SUB: '+ data.shortEntity ,data);
              if (this.dataModule.allowSelectPK != true) {
                this.updateRecordLists(this.checkPermissons(data))
              } else {
                this.updateRecordLists(this.checkPermissons(data))
              }
            }else{
              console.log('no son iguales')
            }
          }
        }
      });
      
      API.graphql({ query: onCloneItem }).subscribe({
        next: (eventData) => {
          console.log(eventData);
          let exist = false
          let pullData = eventData.value.data.onCloneItem;
          let data = JSON.parse(pullData.data)
          if (data.PK = this.organizationID ) {
            this.updateRecordLists(this.checkPermissons(data))
          }
          if (data.shortEntity == 'NOT') {
            this.setNotifications({action:'init'})
          }
        }
      });
      API.graphql({ query: onSetItemState }).subscribe({
        next: (eventData) => {
          let pullData = eventData.value.data.onSetItemState;
          pullData =JSON.parse(pullData.data);
          for (let index = 0; index < this.ramData.data.length; index++) {
            const element = this.ramData.data[index];
            if (element.SK == pullData.SK) {
              console.log(index);
              this.ramData.data.splice(index, 1)
            }
            if (element.shortEntity == 'NOT') {
              this.refreshTable()
            }
          }
        }
      });
    },
    // Data generation for the table ----------------------------------------
    async listDataSet() { 
      //console.clear()
      console.log('listDataSet');
      this.loading('show')
      if (this.pageQuery == "#SML" ) {
        this.pageSize = 0
      }
      /*if (this.pageSize == '') {
        this.pageSize = 100
      }*/
      console.log({
        active: this.activeStatus,
        pagPK: this.dataModule.PK,
        pagSK: this.dataModule.SK,
        dataPK: this.systemType,
        pageSize:this.pageSize,
        lastEvaluatedKey: undefined,
        status: this.statusFilter,
        index:this.rangeFilter,
        date: this.dateFilter,
      },);
      try {
        const wo_PullItem = await API.graphql({
          query: smd_listPAGWithData2,
          variables: {
            active: this.activeStatus,
            pagPK: this.dataModule.PK,
            pagSK: this.dataModule.SK,
            dataPK: this.systemType,
            pageSize:this.pageSize,
            lastEvaluatedKey: undefined,
            status: this.statusFilter, 
            range: this.rangeFilter,
            index: this.dateFilter,
          },
        });
        let pullData =wo_PullItem.data.smd_listPAGWithData2
        console.log('> Data List: ', pullData );
        console.log('> Data Table: ', JSON.parse(pullData.data) );
        //this.ramData.headers = JSON.parse(pullData.header)
        //this.ramData.data = JSON.parse(pullData.data)
        if (pullData.smd_response.statusCode == '200') {   
          this.setRecordLists( { name: this.pageQuery, value: {list:JSON.parse(pullData.data), headers: JSON.parse(pullData.header) } } )
          this.ramData.data = this.recordLists[this.pageQuery].list
          this.ramData.headers = this.recordLists[this.pageQuery].headers
          this.statusTableFilter = JSON.parse(pullData.status)
          this.ramData.headersV2 = formatData('JSON',this.recordLists[this.pageQuery].columnsFormat)
          this.setItemsTable()
        }else{
          this.statusCode(pullData.smd_response)
        }
      } catch (error) {
        console.log(error);
        /*Swal.fire({
          icon: 'error',
          title: 'Something went wrong!' ,
          text: JSON.stringify(error),
          footer: 'list data set',
        })*/
      }
      if (this.pageSize == 0 ) {
        this.pageSize = 100
      }
      this.loading('hide')
    },
    //Table Format
    setTdClass( header ){
      let value = ''
      if (header.format) {
        value = header.format
      }
      return value
    },
    setItemsTable(){
      if (this.pageSize == 0) {
        this.pagination[0] = Math.floor(this.ramData.data.length / 100) +1
        this.pageSize = 100
      }else{
        this.pagination[0] = Math.floor(this.ramData.data.length / this.pageSize) +1
      }
      //this.loading('hidden')
    },
    // Table data editing ----------------------------------------
    refreshTable(type){
      if (type == 'local') {
        this.listDataSet()
      }else{
        this.loading('show')
        this.getRecordLists(this.dataModule)
      }
    },
    f_parentItem(PK, SK){
      console.log();
      console.log(PK,SK);
      if (!PK || !SK) {
        this.parentItem = null
      }else{
        this.parentItem= {
          PK: PK,
          SK: SK,
        }
      }
    },
    async getContactHistory( id ){
      try {
        const wo_PullItem = await API.graphql({
          query: smd_getRootDataSet,
          variables: {
            GSP1PK1: id,
          },
        });
        console.log(wo_PullItem.data.smd_getRootDataSet);
        console.log(JSON.parse(wo_PullItem.data.smd_getRootDataSet.data));
        this.dataHistory = JSON.parse(wo_PullItem.data.smd_getRootDataSet.data)
        
      } catch (error) {
        console.log(error);
      }
    },
    async getItem( sml, edit, pk, sk, parent, action ) { 
      console.log(sml);
      //console.clear();
      this.smlView = sml.sml
      if (this.pageQuery == "#SML" && action != 'delete'  ) {
        this.$router.push({
          query: {
            name:'SMLUP',
            PK:pk,
            SK:sk,
          },
        });
        console.log('return');
        return
      }
      this.loading('show', 'getItem')
      this.entityItem = { PK: sml.entity.PK,  SK: sml.entity.SK}
      if (parent == true) {
        this.f_parentItem( pk, sk)
        pk = undefined
        sk = undefined
      }else{
        //else.parse()
        this.parentItem = null
        console.log(this.dataModule);
        this.shortEntityItem = this.pageQuery
      }
      this.itemPK = pk
      this.itemSK = sk
      //console.log('edit: '+ edit);
      if (edit == true) {
        this.edit = false
      }else{
        this.edit = true
      }
      // Cont Combo
      this.layout = []
      this.models = []
      let itemGlobal = ''
      console.log(sml);
      try {   
        console.log(this.parentItem) 
        if (sk) {
          console.log("%cEdit Mode\nPK:" + pk + ",  SK:" + sk, "color:#6BF01A");
          this.mode = "edit";
          let w_fileData =[]
          this.w_fileData = w_fileData
          try {
            const wo_PullItem = await API.graphql({
              query: smd_getSMLItem,
              variables: {
                itemPK: pk,
                itemSK: sk,
                SMLPK: sml.sml.PK,
                SMLSK: sml.sml.SK,
                parent: this.parentItem,
                entity:{
                  PK: sml.entity.PK,
                  SK: sml.entity.SK,
                }
              },
            });
            console.log("--> Data of Query :", this.goodFormat( wo_PullItem.data.smd_getSMLItem, 'json' ) );
            let item = JSON.parse(wo_PullItem.data.smd_getSMLItem.data)
            this.layout = JSON.parse(wo_PullItem.data.smd_getSMLItem.data)
            this.layoutName = wo_PullItem.data.smd_getSMLItem.layoutName
            this.layoutCategory = wo_PullItem.data.smd_getSMLItem.layoutCategory
            itemGlobal = JSON.parse(wo_PullItem.data.smd_getSMLItem.item)
            this.models = itemGlobal.attributes
            function isObjEmpty(obj) {
              return Object.keys(obj).length === 0;
            }
            console.log("Is models Empty? : ", isObjEmpty(this.models));
            
            console.log("--> Layout:\n ", this.goodFormat( item, 'json' )); //View Item
            console.log("--> item detail:\n ", this.goodFormat(itemGlobal, 'json')); //View Item
            console.log("--> Models: ", this.goodFormat(this.models, 'json')); //View Item
            if (parent == true) {
              this.shortEntityItem = JSON.parse(wo_PullItem.data.smd_getSMLItem.item).shortEntity
            }
            this.parent = itemGlobal.GSP1PK1
            this.systemType = itemGlobal.PK
            this.cretedBy = itemGlobal.createdBy
            this.responsable = itemGlobal.responsable
            this.dataVersion = itemGlobal.version
            this.usersCanEdit = itemGlobal.usersCanEdit
            this.usersCanRead = itemGlobal.usersCanRead
            this.groupsCanEdit = itemGlobal.groupsCanEdit
            this.groupsCanRead = itemGlobal.groupsCanRead
            this.permissionsStr = {
              usersCanEdit: JSON.stringify(this.usersCanEdit),
              usersCanRead: JSON.stringify(this.usersCanRead),
              groupsCanRead: JSON.stringify(this.groupsCanRead),
              groupsCanEdit:  JSON.stringify(this.groupsCanEdit),
            }
            
          } catch (error) {
            console.log(error);
          }
        } 
        else {
          console.log("%cNew Mode\nPK:" + pk, "color:#0084ff");
          this.mode = "new";
          const wo_PullItem = await API.graphql({
            query: smd_getSMLItem,
            variables: {
              SMLPK: sml.sml.PK,
              SMLSK: sml.sml.SK,
              parent: this.parentItem,
              entity:{
                PK: sml.entity.PK,
                SK: sml.entity.SK,
              }
            },  
          });
          console.log("--> Data of Query :", this.goodFormat(wo_PullItem.data.smd_getSMLItem, 'json') );
  
          let item = JSON.parse(wo_PullItem.data.smd_getSMLItem.data)
          itemGlobal = JSON.parse(wo_PullItem.data.smd_getSMLItem.item)
          this.layoutName =wo_PullItem.data.smd_getSMLItem.layoutName
          this.models = itemGlobal.attributes
          this.parent = itemGlobal.GSP1PK1
          if (Object.keys(this.models).length === 0) {
            try {
              console.log('Models esta vacio por default')
              this.models = JSON.parse(itemGlobal.strAtt)
            } catch (error) {
              console.log('Models esta vacio por default y no se pude parsear strAtt')
            }
          }
          this.layout = JSON.parse(wo_PullItem.data.smd_getSMLItem.data)
          console.log("--> Layout:\n ", this.goodFormat( this.layout, 'json' )); //View Item
          console.log("--> item detail:\n ", this.goodFormat(itemGlobal, 'json')); //View Item
          console.log("--> Models: ", this.goodFormat(this.models, 'json')); //View Item
  
          if (parent == true) {
            console.log(JSON.parse(wo_PullItem.data.smd_getSMLItem.item));
            this.shortEntityItem = JSON.parse(wo_PullItem.data.smd_getSMLItem.item).shortEntity
          }
        }
        if (itemGlobal.SK) {
          for (let index = 0; index < this.entities.length; index++) {
            const element = this.entities[index];
            if (element.SK == this.entity.SK) {
              this.entityView = element
            }
          }
        }else{
          for (let index = 0; index < this.entities.length; index++) {
            const element = this.entities[index];
            if (element.SK == this.entity.SK) {
              this.entityView = element
            }
          }
        }

      } catch (error) {
        console.log(error);
        Swal.fire({
          icon: 'error',
          title: 'Something went wrong!' ,
          text: error,
          footer: 'getItem = smd_getSMLItem PK:  '+ pk + ', SK: ' +sk,
        })
      }
      this.modelsStr = []
      this.modelsStr = JSON.stringify(this.models)
      this.itemView = itemGlobal
      console.log(this.itemView);
      this.loading('close', 'getItem')
    },
    async f_updateRecord(sk, models) {  
      this.loading('show', 'f_updateRecord')
      //console.log(this.mode);
      try {
        let push =''
        if (this.dataModule.allowSelectPK == false) {
          if (this.mode == 'new') {
            this.systemType = this.organizationID
          }else{
            this.systemType = this.itemView.PK
          }
        }
        for (const key in models) {
          try {
            if (models[key].type == 'L' ) {
              if (models[key].value != '') {
                models[key].value = JSON.stringify(models[key].value)
              }else{
                models[key].value = "[]"
              }
            }
          } catch (error) {
            console.error(error);
          }
        }
        if (this.mode == 'edit') {
          this.entityItem = this.itemView.entity 
          this.parentItem = this.itemView.parent
        }
        console.log('--> Data enviada',this.goodFormat(models, 'json'));
        console.log('--> Data Global - '+ this.systemType + ' - '+ sk);
        console.log({
          shortEntity: this.shortEntityItem,
          PK: this.systemType,
          SK: sk,
          attributesStr: JSON.stringify(models) ,
          entity: this.entityItem,
          form: {             
            PK: this.smlView.PK,
            SK: this.smlView.SK,
          },
          parent: this.parentItem,
          usersCanEdit: this.usersCanEdit,
          usersCanRead: this.usersCanRead ,
          groupsCanEdit: this.groupsCanEdit,
          groupsCanRead: this.groupsCanRead,
        });
        push = await API.graphql({
          query: smd_updateSmartRecord, //smd_updateSmartRecord
          variables: { 
            input:{
              shortEntity: this.shortEntityItem,
              PK: this.systemType,
              SK: sk,
              attributesStr: JSON.stringify(models) ,
              entity: this.entityItem,
              form: {             
                PK: this.smlView.PK,
                SK: this.smlView.SK,
              },
              parent: this.parentItem,
              usersCanEdit: this.usersCanEdit,
              usersCanRead: this.usersCanRead ,
              groupsCanEdit: this.groupsCanEdit,
              groupsCanRead: this.groupsCanRead,
            }
          },
        });
        console.log("Creado exitosamente");
        console.log('--> Datos Recibidos',this.goodFormat(push, 'json'));
        push = push.data.smd_updateSmartRecord
        console.log(push);
        console.log('--> Binds',JSON.parse(push.data));
        if (push.smd_response.statusCode == 200) {
          this.itemView = JSON.parse(push.data)
          if (this.itemSK == undefined || this.itemSK == '') {        
            this.itemPK=JSON.parse(push.data).PK
            this.itemSK=JSON.parse(push.data).SK
          }
          this.models = JSON.parse(push.data).attributes
          //Review
          for (const key in this.models) {
            try {
              //console.log(key+': ',this.models[key]);
              if (this.models[key].type == 'L' && this.models[key].value != '') {
                this.models[key].value = JSON.parse(this.models[key].value)
              }
              if( this.models[key].type == 'parentChildren' ){
                let pullData = await API.graphql({
                  query: smd_getRootPhonesEmails,
                  variables:{
                    GSP1PK1:JSON.parse(push.data).GSP1PK1,
                    GSP1SK1:JSON.parse(push.data).GSP1SK1,
                  }
                })
                pullData = pullData.data.smd_getRootPhonesEmails
                this.models[key].externalValue = JSON.parse(pullData.data)[key.toLowerCase()]
              }
            } catch (error) {
              console.error('--> Error \n '+ key+' --> ',this.goodFormat(this.models[key], 'json') );
            }
          } 
          console.log('----------------------------------------');
          this.modelsStr = [] //OLD
          this.modelsStr = JSON.stringify(this.models)//OLD
        }else{
          for (const key in this.models) {
            try {
              //console.log(key+': ',this.models[key]);
              if (this.models[key].type == 'L' && this.models[key].value != '') {
                this.models[key].value = JSON.parse(this.models[key].value)
              }
              if( this.models[key].type == 'parentChildren' ){
                let pullData = await API.graphql({
                  query: smd_getRootPhonesEmails,
                  variables:{
                    GSP1PK1:JSON.parse(push.data).GSP1PK1,
                    GSP1SK1:JSON.parse(push.data).GSP1SK1,
                  }
                })
                pullData = pullData.data.smd_getRootPhonesEmails
                console.log(JSON.parse(pullData.data)[key.toLowerCase()]);
                this.models[key].externalValue = JSON.parse(pullData.data)[key.toLowerCase()]
                console.log(this.models[key]);
              }
            } catch (error) {
              console.error('--> Error \n '+ key+' --> ',this.goodFormat(this.models[key], 'json') );
            }
          } 
          Swal.fire({
          icon: 'warning',
          title: 'Code:'+push.smd_response.statusCode  ,
          text: push.smd_response.message,
          footer: 'update',
        })
        }
      } catch (error) {
        for (const key in this.models) {
          try {
            //console.log(key+': ',this.models[key]);
            if (this.models[key].type == 'L' && this.models[key].value != '') {
              this.models[key].value = JSON.parse(this.models[key].value)
            }
            if( this.models[key].type == 'parentChildren' ){
              let pullData = await API.graphql({
                query: smd_getRootPhonesEmails,
                variables:{
                  GSP1PK1:JSON.parse(push.data).GSP1PK1,
                  GSP1SK1:JSON.parse(push.data).GSP1SK1,
                }
              })
              pullData = pullData.data.smd_getRootPhonesEmails
              console.log(JSON.parse(pullData.data)[key.toLowerCase()]);
              this.models[key].externalValue = JSON.parse(pullData.data)[key.toLowerCase()]
              console.log(this.models[key]);
            }
          } catch (error) {
            console.error('--> Error \n '+ key+' --> ',this.goodFormat(this.models[key], 'json') );
          }
        }
        console.log(error)
        Swal.fire({
          icon: 'error',
          title: 'Something went wrong!' ,
          text: JSON.stringify(error),
          footer:'f_updateRecord'
        })
      }
      this.mode = 'edit'
      this.loading('close','f_updateRecord')
    },
    async userCreated(item) {
      console.log(item);
      let push =''
      try {        
        push = await API.graphql({
          query: smd_addUserWithPermits,
          variables: { 
            userName: item["sml.contactFullName"]['contact.firstName'] ,
            userEmail: '',
            userOrg: item.PK,
            password: '',
            GSP1PK1: item.SK,
          },
        });
        console.log(push.data.smd_addUserWithPermits)
        Swal.fire(
          'Info',
          `${ JSON.stringify(push.data.smd_addUserWithPermits.smd_response, null, 4)}`,
          'success'
        )
      } catch (error) {
        console.log(error);
        Swal.fire( {
          icon: 'error',
          title: 'Something went wrong!' ,
          text: error
          }
        )
      }
    },
    async setStatus(pk, sk, action) {
      console.log(pk, sk);
      let status = ''
      let push =''
      if (action == 'active') {
        status ='1'
      }
      if (action == 'desactive') {
        status= '0'
      }
      if (action == 'archive') {
        status = '2'
      }
      console.log(action+'-'+status);
      push = await API.graphql({
        query: smd_setItemState,
        variables: { PK: pk, SK: sk, state: status},
      });
      console.log('After Query');
        console.log(push.data.smd_setItemState);
        console.log(action+": " + pk + " - " + sk);
    },
    async setFavorite(PK, SK) {
      let pushData = ''
      try {
        pushData = await API.graphql({
          query: smd_addToFavorites,
          variables: { 
            PK: PK,
            SK: SK
          },
        });
        pushData = pushData.data.smd_addToFavorites
        console.log(pushData);
        Swal.fire(
          'Info',
          `${JSON.stringify(pushData)}`,
          'success'
        )
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Something went wrong!' ,
          text: JSON.stringify(error.errors)
        })
      }
    },
    async setClone(PK, SK) {
      let pushData = ''
      try {
        pushData = await API.graphql({
          query: smd_cloneSmartRecord,
          variables: { 
            PK: PK,
            SK: SK
          },
        }); 
        pushData = pushData.data.smd_cloneSmartRecord
        console.log(pushData.smd_response);
        Swal.fire({
          icon: 'success',
          title: 'Successfully cloned' ,
          //text: pushData.smd_response.statusCode
        })
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Something went wrong!' ,
          text: JSON.stringify(error)
        })
      }
    },
    f_actions(PK, SK){
      this.f_parentItem(PK, SK)
    },
    f_pushInput(data ) {
      let processedData = data
      for (const key in data.attributes) {
        try {
          if (data.attributes[key].type == 'L') {
            processedData[key] = JSON.parse(data.attributes[key].value)
          }else{
            processedData[key] = data.attributes[key].value
          }
        } catch (error) {
          console.log(key, error);
        }
      }
      delete processedData.attributes
      console.log(processedData);
      try {
        if (this.mode == "new") {
          processedData.subscribe = true
          this.recordLists[data.shortEntity].list.splice(0, 0, processedData);    
        } else {
          for (let index = 0; index < this.recordLists[data.shortEntity].list.length; index++) {
            const item = this.recordLists[data.shortEntity].list[index];
            if (item.SK == data.SK) {
              this.recordLists[data.shortEntity].list[index] = processedData
              switch (data.active) {
                case '0':
                  delete this.recordLists[data.shortEntity].list.splice(index, 1)
                break;
                case '1':
                  this.updateRecordLists(data)
                break;
                case '2':
                  delete this.recordLists[data.shortEntity].list.splice(index, 1)
                break;
              }
            }
          }
        }
        if (this.pageQuery == data.shortEntity) {
          this.ramData.data = this.recordLists[data.shortEntity].list
        }
      } catch (error) {
        console.log(error);
      }
    },
    async setEditor(SK){
      //console.clear()
      try {
        setTimeout(() => {
          $(`#editor${SK}`).trumbowyg({
            svgPath: false,
            hideButtonTexts: true
          });
          document.getElementById(`editor${SK}`).innerHTML = document.getElementById(`editor${SK}`).innerHTML + ''
        }, 100);
      } catch (error) {
        
      }
    },
    setDataEditor(component,index, td){
      try {
        setTimeout(() => {
          //this.models[component.attributeName].value = escape(document.getElementById(`editor${index}`).innerHTML)
        }, 100);
      } catch (error) {
        
      }
    },
    applyFilter(name){
      setTimeout(() => {
        for (let zindex = 0; zindex < this.ramData.headers.length; zindex++) {
          if(this.ramData.headers[zindex].label == name){
            this.filterTable(zindex+1)
          }
        }
        
      }, 100);
    },
    filterTable(index){
      console.log(index); 
      let table = document.getElementById("myTable");
      setTimeout(() => { 
        for (let vindex = 0; vindex < table.rows.length; vindex++) {
          console.log('-------------------------------');
          const element = table.rows[vindex];
          table.rows[vindex].classList.add('displayNone')
          //console.log(JSON.parse(element.attributes.target.value));
          let view = true

          this.valueFilter.forEach(value => {
            console.log('>'+value+'<');
            console.log(JSON.parse(element.attributes.target.value).includes(value))
            if (JSON.parse(element.attributes.target.value).includes(value)) {
              if (view == true) {
                view = true
              }else{
                view = false
              }
            }else{
              view = false
            }
          });

          console.log('View --> '+view);
          if (view == true) {
            console.log(table.rows[vindex]);
            table.rows[vindex].classList.remove('displayNone')
          }else{
            table.rows[vindex].classList.add('displayNone')
          }
        }
      }, 100);
    },
    blank(id){
      console.log(id);
      setTimeout(() => {
        $('#modal-update').modal('show')
        let button = document.getElementById(id);
        console.log(button);
        var event = new Event('click');
        button.dispatchEvent(event);
        console.log(event);
      }, 1500);
    },
    // Functionality
    clearSearch(){
      this.v_search = ''
      this.searchList()
      this.f_search()
    },
    searchList(){
      let pushData = []
      this.loading('show', 'searchList')
      let table = this.recordLists[this.pageQuery].list
      //console.log(table.length);
      for (let index = 0; index < table.length; index++) {
        const element = table[index];
        let exist = false
        for (let zindex = 0; zindex < this.ramData.headers.length; zindex++) {
          const header = this.ramData.headers[zindex].attributeName;
          let value = ''
          try {
            let value = element[header]
            console.log();
            if (typeof value != 'string') {
              value = JSON.parse(element[header])
            }
            if ( typeof value == 'number' ||  typeof value == 'object') {
              value = JSON.stringify(value)
            }
            if (value != '') {
              value = value.toLowerCase()
            }
            if (value.includes(this.v_search.toLowerCase())) {
              exist = true
            }
          } catch (error) {
            //console.log(value);
            //console.log(error);
          }
        }
        if (exist == true) {
          pushData.push(table[index])
        }
      }
      this.ramData.data = pushData
      this.pagination[1] = 0
      this.loading('hidden', 'searchList')
    },
    async buttonsView(action){
      try {
        let buttonSave = await document.getElementById('save-'+this.itemSK)
        let buttonSaveClose = await document.getElementById('saveClose-'+this.itemSK)
        if (action == 'show') {
          buttonSave.classList.add('show')
          buttonSaveClose.classList.add('show')
        }else{
          buttonSave.classList.remove('show')
          buttonSaveClose.classList.remove('show')
        }
      } catch (error) {
        //console.log(error);
      }
    },
    closeInternalModal(id){
      $('#modal-'+id).modal('hide');
    },
    exportAs(as, entity){
      let nameFile = ''
      for (let index = 0; index < this.entities.length; index++) {
        const element = this.entities[index];
        if (element.SK == entity) {
          element.attributes.forEach(att => {
            if (att.attributeName == 'metaEntity.name' ) {
              nameFile = att.attributeValue+"-"+this.itemSK
            }
          });
        }
      }
      try {
        switch (as) {
          case 'pdf':
            var element = document.getElementById('layout-preview');
            var opt = {
              margin: [9, 20],
              filename: nameFile.toLowerCase()+'.pdf',
            };
            html2pdf(element,opt); 
          break;
        }
      } catch (error) {
        
      }
    },
    async f_emailTemplates(action, PK, SK, item){
      console.log(action);
      switch (action) {
        case 'list':
          try {
            this.toEmail = ""
            this.subjectEmail=""
            document.getElementById('editor'+this.itemSK).innerHTML = ""
            this.itemView = item
            this.itemPK = PK
            this.itemSK = SK
            const wo_PullItem = await API.graphql({
              query: smd_listEntityObj,
              variables: {
                active: '1' ,
                PK: this.organizationID,
                shortEntity: 'EMT',
                pageSize: 0 ,
              },
            });
            console.log(wo_PullItem.data.smd_listEntityObj);
            console.log(JSON.parse(wo_PullItem.data.smd_listEntityObj.data));
            this.emailTemplates = JSON.parse(wo_PullItem.data.smd_listEntityObj.data)
          } catch (error) {
            console.log(error);
          }
        break;
        case 'set':
          try {           
            console.log(this.organizationID +'-'+ SK);
            console.log(this.itemView.GSP1PK1);
            console.log( {
              emailTPK: this.organizationID,
              emailTSK: SK,
              itemPK: this.organizationID,
              itemSK: this.itemView.SK,
              itemGSP1PK1: this.itemView.GSP1PK1,
              itemGSP1SK1: this.itemView.GSP1SK1,
              baseURL: window.location.origin, 
            });
            let pullData = await API.graphql({
              query: smd_composeEmailTemplate,
              variables: {
                emailTPK: this.organizationID,
                emailTSK: SK,
                itemPK: this.organizationID,
                itemSK: this.itemView.SK,
                itemGSP1PK1: this.itemView.GSP1PK1,
                itemGSP1SK1: this.itemView.GSP1SK1,
                baseURL: window.location.origin, 
              },
            });
            pullData = pullData.data.smd_composeEmailTemplate
            console.log(pullData);
            this.toEmail = ''
            this.toEmail = JSON.parse(pullData.data).emails
            this.subjectEmail = JSON.parse(pullData.data).subject
            this.dataEditor = unescape(JSON.parse(pullData.data).body)
            document.getElementById('editor'+this.itemSK).innerHTML = unescape(this.dataEditor).replace(/QUO#/g,'QUO%23')
          } catch (error) {
            console.log(error);
          }
        break;
        case 'send':
          try {              
            let push = ''
            this.dataEditor = document.getElementById('editor'+this.itemSK).innerHTML
            console.log(this.dataEditor);
            push = await API.graphql({
              query: smd_sendEmail2, //smd_updateSmartRecord
              variables: {
                to: this.toEmail,
                subject: this.subjectEmail,
                bodyHTML: this.dataEditor
              },
            });
            console.log('eviado exitosament');
            console.log(push);
            //smd_sendEmail2(bodyHTML: "hello hello", to: "marcelo@bizplaneasy.comm", subject: "hola from lambda")
            Swal.fire({
              icon: 'success',
              title: 'Mail sent successfully' ,
              //text: JSON.stringify(error),
            })
          } catch (error) {
            console.log(error);
          }
        break;
        case 'editor':
          try {       
            this.itemPK = PK
            this.itemSK = SK
            setTimeout(() => {      
              this.setEditor(SK)
            }, 1000);
          } catch (error) {
            console.log(error);
          }
        break;
        case 'editorQuote':
          try {       
            this.itemPK = PK
            this.itemSK = SK
            setTimeout(() => {
              console.log('HOLA');       
              this.setEditor(SK)
              this.f_emailTemplates('set','ORG#BIZPLANEASY' ,'EMT#87a578c4-f64c-44d1-b5bf-268299bd9958')
              this.f_emailTemplates('list','ORG#BIZPLANEASY' )
            }, 1000);
            try {
              
            } catch (error) {
              
            }
          } catch (error) {
            console.log(error);
          }
        break;
      }
    },
    sortTable(n) {
      this.loading('show','sortTable')
      console.log(' Short Table: '+n);
      var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
      table = document.getElementById("myTable");
      switching = true;
      dir = "asc";
      while (switching) {
        switching = false;
        rows = table.rows;
        for (i = 0; i < rows.length - 1; i++) {
          shouldSwitch = false;
          x = rows[i].getElementsByTagName("TD")[n];
          y = rows[i+1].getElementsByTagName("TD")[n];
          if (dir == "asc") {
            if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
              shouldSwitch = true;
              break;
            }
          } else if (dir == "desc") {
            if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
              shouldSwitch = true;
              break;
            }
          }
        }
        if (shouldSwitch) {
          rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
          switching = true;
          switchcount++;
        } else {
          if (switchcount == 0 && dir == "asc") {
            dir = "desc";
            switching = true;
          }
        }
      }
      this.loading('hidden', 'sortTable')
    },
    searchItems( id , container ) {
      console.clear()
      let value = document.getElementById(id).value
      let list = document.getElementById(container)
      console.log(value);
      for (let index = 0; index < list.children.length; index++) {
        const element = list.children[index];
        console.log(document.getElementById(container).children[index]);
        console.log(element.innerText.toLowerCase() +' - '+value.toLowerCase() );
        if (element.innerText.toLowerCase().includes(value.toLowerCase()) ) {
          document.getElementById(container).children[index].style = ""
        }else{
          document.getElementById(container).children[index].style = "display:none;"
        }
      }
    },
    f_search() {
      //console.clear()
      let table = document.getElementById("myTable");
      let tr = table.children[1].children;
      for (let index = 0; index < tr.length; index++) {
        let w_td = tr[index].children
        table.children[1].children[index].classList.add("searchTable");
        for (let w_i_td = 0; w_i_td < w_td.length - 1; w_i_td++) {
          if (table.children[1].children[index].children[w_i_td].innerText.toLowerCase().includes(this.v_search.toLowerCase())) {
            //console.log(table.children[1].children[index].children[w_i_td].innerText);
            table.children[1].children[index].classList.remove("searchTable");
            //Resaltado
            //table.children[1].children[index].children[w_i_td].innerHTML = tr[index].children[w_i_td].innerText.replace(this.v_search.toLowerCase(), '<span style="color:#29a72e;font-weight:bolder">' + this.v_search.toLowerCase() + "</span>");
          }
        }
      }
    },    
    f_hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },
    f_itemValue(item, column) {
      let td = ""
      try {
        if (item[column]) {
          if (item[column].id && item[column].value) {
            td = item[column].value
          }else{
            td = item[column]
          }
        }else{
          td = ""
        }
      } catch (error) {
        console.log(error);
      }
      return  td
    },
    f_itemValueCombo(item, column) {
      let td = ""
      if (item[column]) {
        td = item[column]
      }else{
        td = "..."
      }
      return  td
    },
    async msmActions(action, data){
      switch (action) {
        case 'init':
          console.log(data);
          this.dataSMS.options = []
          this.dataSMS.message = ''
          this.dataSMS.PK = data.PK
          switch (data.shortEntity) {
            case "CON":
              this.dataSMS.options = data.SMLPhones
            break;
            case "PHO":
              this.dataSMS.phone = data.SK
            break;
            case "PHC":
              this.dataSMS.phone = 'PHO#'+data.phoneNumber
            break;
          }
        break;
        case 'send':
          let push = ''
          let config = {}
          try {     
            
            config={
              phonePK: data.PK,
              phoneSK: data.phone,
              message: data.message
            }
            console.log(config);
            push = await API.graphql({
              query: smd_sendSMS, //smd_updateSmartRecord
              variables: config
            });
            console.log('eviado exitosament');
            console.log(push);
            //smd_sendEmail2(bodyHTML: "hello hello", to: "marcelo@bizplaneasy.comm", subject: "hola from lambda")
            Swal.fire({
              icon: 'success',
              title: 'SMS sent successfully' ,
              //text: JSON.stringify(error),
            })
          } catch (error) {
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'error' ,
              text: JSON.stringify(error),
            })
          }
        break;
      }
    },
  },
  computed: {
    ...Vuex.mapState([
      "organizationID",
      "pageQuery", 
      "entity", 
      "pageMeta",
      "user", 
      "pageModule", 
      "permissions",
      "userPermissions", 
      "rows", 
      "entities", 
      "allowPK",
      "dataUser", 
      'organizationData',
      'preloadLists',
      'preloadList', 
      'recordLists',
      'dataModule',
      'recordSub',
    ]),
  },
  watch:{
    pageQuery:function(value) {
      if (this.dataModule.allowSelectPK == true) {
        this.systemType = '#SMARTDASH'
      }else{
        this.systemType = this.organizationID
      }
      //this.f_ListDataSet(value)
    },
    models:{
      handler(val) {
        this.goodFormat(val,'string')
        if (JSON.stringify(val) == this.modelsStr) {
          this.buttonsView('hide')
        }else{
          this.buttonsView('show')
        }
      },
      deep: true
    },
    groupsCanEdit:{
      handler(val) {
        setTimeout(() => {
          if (JSON.stringify(val) != this.permissionsStr.groupsCanEdit) {
            this.buttonsView('show')
            console.log('diferente');
          }else{
            console.log('igual');
            this.buttonsView('hide')
          }
        }, 200);
      },
      deep: true
    },
    groupsCanRead:{
      handler(val) {
        setTimeout(() => {
          if (JSON.stringify(val) != this.permissionsStr.groupsCanRead) {
            this.buttonsView('show')
            console.log('diferente');
          }else{
            console.log('igual');
            this.buttonsView('hide')
          }
        }, 200);
      },
      deep: true
    },
    usersCanEdit:{
      handler(val) {
        setTimeout(() => {
          if (JSON.stringify(val) != this.permissionsStr.usersCanEdit) {
            this.buttonsView('show')
            console.log('diferente');
          }else{
            console.log('igual');
            this.buttonsView('hide')
          }
        }, 200);
      },
      deep: true
    },
    usersCanRead:{
      handler(val) {
        setTimeout(() => {
          if (JSON.stringify(val) != this.permissionsStr.usersCanRead9) {
            this.buttonsView('show')
            console.log('diferente');
          }else{
            console.log('igual');
            this.buttonsView('hide')
          }
        }, 200);
      },
      deep: true
    },
    dataModule:{
      handler(val) {
        try {
          console.log(this.entities);
          console.log(this.dataModule['modules.dataQuery']);
          if (this.entities[this.dataModule['modules.dataQuery']].defaultStatus == undefined) {
            this.statusFilter = 'All'
            this.setFilterData(['statusFilter',this.statusFilter])
          }else{
            this.statusFilter = this.entities[this.dataModule['modules.dataQuery']].defaultStatus
            this.setFilterData(['statusFilter',this.statusFilter])
          }
          console.log(this.statusFilter);
          this.statusFilter = ''
          if (val.allowSelectPK == true) {
            this.systemType = '#SMARTDASH'
          }else{
            this.systemType = this.organizationID
          }
          if (val.preload == true ) {
            this.ramData.data = this.recordLists[val['modules.dataQuery']].list
            this.ramData.headers = this.recordLists[val['modules.dataQuery']].headers
            this.ramData.headersV2 = this.recordLists[val['modules.dataQuery']].headersV2
          }else{
            this.pageSize = this.dataUser.rows.value
            this.valueFilter = []
            this.listDataSet();
          }
          //this.clearSearch()
          this.setItemsTable()
          
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Something went wrong!' ,
            text: error,
            footer: 'dataModule',
          })
          console.log(error);
          console.log(val)
        }
      },
      deep: true
    },
    recordLists:{
      handler(val) {
        this.loading('show','View recordLists')
        //console.log('CAMBIO');
        if (this.dataModule.preload == true ) {
          this.ramData.list = this.recordLists[this.dataModule['modules.dataQuery']].list
          this.ramData.headers = this.recordLists[this.dataModule['modules.dataQuery']].headers
          this.ramData.headersV2 = this.recordLists[this.dataModule['modules.dataQuery']].headersV2
        }
        this.setItemsTable()
        this.searchList()
        this.loading('hidden','View recordLists')
      },
      deep: true
    }
  }
}
</script>
